/* eslint jsx-a11y/media-has-caption: 0 */
/* eslint react/jsx-one-expression-per-line: 0 */

import React from "react";
import styled, { css } from "styled-components";
import { Link } from "react-router-dom";

import {
  BlockCinema,
  Carousel,
  FilmCover,
  Footer,
  Freedom,
  NamedHeader,
  PageIntroKnaifel,
  QuoteCinema,
  SidesKnaifel,
  Spacer,
  SubTitle,
  Text,
  Title,
  TypographyWrapper,
} from "../../../lib";
import { mediaQuery } from "../../../utils";

const { PUBLIC_URL } = process.env;

export const NBSP = () => <span style={{ opacity: 0 }}>[</span>;

const QuoteCinemaText = styled(Text)`
  text-transform: lowercase;
`;

const Image = styled.img`
  width: 100%;
`;

const SourceText = styled(Text)`
  font-style: italic;
  text-align: right;
`;

const StyledTitle = styled(Title)`
  color: #fff;
  display: inline-BlockCinema;
  font-size: 36px;
  line-height: 36px;
  margin-left: 65vw;
  right: 20px;
  transform: translateY(-8vw);

  ${mediaQuery(
    "phone",
    css`
      font-size: 16px;
      margin-left: 50vw;
      transform: scale(0.7) translateY(-32vw) translateX(6vw);
    `
  )}
`;

const Cinema: React.FC = () => {
  document.body.style.overflowX = "hidden";

  return (
    <TypographyWrapper>
      <NamedHeader name="кино" />

      <PageIntroKnaifel author="knaifel" name="cinema" />
      <Spacer size={10} />

      <Carousel
        autoHeight
        showIndicators={false}
        slides={[
          { url: `${PUBLIC_URL}/assets/images/knaifel/cinema/00/top.jpg` },
        ]}
      />

      <StyledTitle>
        <div style={{ marginTop: window.innerWidth > 768 ? 0 : 34 }}>
          <span style={{}}>Когда возникает музыка –</span>
          <br />
          <span style={{ marginLeft: window.innerWidth > 768 ? 50 : 40 }}>
            сценарий вырастает своей первой буквой
          </span>
        </div>
      </StyledTitle>

      {/* ---------------------------------------------------------- */}
      {/* <Spacer size={15} /> */}
      <FilmCover
        director="реж. яков склянский"
        name="«жидкие кристаллы»"
        url={`${PUBLIC_URL}/assets/images/knaifel/cinema/01/1.jpg`}
        year="1973"
      />
      <Spacer half size={8} />
      <SidesKnaifel>
        <BlockCinema>
          <SubTitle>начало. леннаучфильм</SubTitle>
          <Text>александр кнайфель:</Text>
          <>
            Я не напрашивался, но я кинематографический человек, в детстве
            мечтал быть кинорежиссером, и в юности даже сочинил пьесу для
            киноленты.
          </>
          <>
            Начинал я на Ленинградской студии научно-популярных и учебных
            фильмов – «Леннаучфильме». Тогда там собралась элита: режиссеры,
            художники, фотографы – замечательные люди, все они подрабатывали.
          </>
          <>
            Для этой студии отпускались деньги, писались сценарии, все было
            основательно. Давали возможность записывать и музыку. По регламенту,
            правда, полагались небольшие составы: вместо оркестра собирали
            изощренные ансамбли, самые разные – от старинных инструментов до
            современных, но можно было делать все, что угодно.
          </>
          <>
            Для музыкантов это были настоящие каникулы, главное, что они были
            открыты – им чем неожиданней, тем лучше. Не только делай, что
            хочешь, а делай, что можешь – делай! Я там опробовал массу всего.
            Пиши себе – да еще исполняют, платят.
          </>
          <Spacer half size={4} />
          <SubTitle>жидкие кристаллы</SubTitle>
          <>
            Первый фильм назывался
            <NBSP />
            <a
              href="https://tst1.net-film.ru/film-60448/ "
              style={{
                borderBottom: "1px solid #ccc",
              }}
            >
              «Жидкие кристаллы»
            </a>
            . Его делал Яков Склянский. Он снял потрясающие кадры под каким-то
            микроскопом про феномен этих жидких кристаллов. Самая настоящая
            живопись невероятной красоты – жизнь неведомая, интенсивная.
            Потратил на это десятки, если не сотни, метров пленки, оторваться
            было невозможно, можно смотреть часами.
          </>
          <Spacer half size={4} />
          <SubTitle>марсианская музыка на миллиметровке</SubTitle>
          <>
            Он пригласил меня писать музыку. А как? Там вообще ничего нет,
            марсианское нечто. Я взял миллиметровую бумагу и стал графически
            записывать инструменты, голос… Сам при этом совершенно не понимая,
            как это можно будет исполнить.
          </>
          <Spacer half size={4} />
          <Image
            alt="Александр Кнайфель"
            src={`${PUBLIC_URL}/assets/images/knaifel/cinema/01/2.jpg`}
          />
          <>
            А потом потянулось-потянулось, из самых разных сфер: «Жизнь в
            магнитном поле», «Полярный эксперимент», «Настанет день», «Энергия»,
            «Лед и пламень», «Парад изобретений». Я стал везде хулиганить. [C—A]
          </>
          <Spacer half size={4} />
          <Carousel
            autoHeight
            slides={[
              { url: `${PUBLIC_URL}/assets/images/knaifel/cinema/01/3.jpg` },
              { url: `${PUBLIC_URL}/assets/images/knaifel/cinema/01/4.jpg` },
            ]}
          />
          <Spacer half size={4} />
          <Carousel
            autoHeight
            slides={[
              { url: `${PUBLIC_URL}/assets/images/knaifel/cinema/01/5.jpg` },
              { url: `${PUBLIC_URL}/assets/images/knaifel/cinema/01/6.jpg` },
            ]}
          />
          <Spacer half size={4} />
          <QuoteCinema>
            <QuoteCinemaText>татьяна мелентьева:</QuoteCinemaText>
            <>
              Он один из немногих композиторов, кто жил за счет своего
              творчества. Не преподавал, совсем немного проработал в
              издательстве, он зарабатывал композиторским трудом. Это не всем
              удается.
              <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
                <Link to="/knaifel/source">[C—B]</Link>
              </sub>
            </>
          </QuoteCinema>
          <Spacer half size={4} />
          <SubTitle>поштучно</SubTitle>
          <Text>александр кнайфель:</Text>
          <>
            Профессионализм на студии был невероятный, фильмы были небольшие,
            обычно одночастные, надо было как-то уложиться в эти десять минут. И
            фонограммы действительно удивляли. Все штучное. У меня стихийно
            сложился принцип – никогда ничего не повторять. Просто не могу. Я
            уже совсем другой – все клетки обновились, зачем я буду оглядываться
            и вспоминать? C—A]
          </>
          <Spacer half size={4} />
          <SubTitle>прямой мостик</SubTitle>
          <>
            Кстати говоря, благодаря этому опыту я и вылупился. Когда [на
            «Ленфильме»] стали снимать «След росомахи», услышали мою фонограмму,
            сделанную исключительно на голосах, и позвали. Ну тут уж, думаю, раз
            так – получите! И получили. Так что это был прямой мостик. [C—A]
          </>
        </BlockCinema>
      </SidesKnaifel>

      {/* ---------------------------------------------------------- */}
      <Spacer size={15} />
      <FilmCover
        director="реж. георгий кропачев"
        name="«след росомахи»"
        url={`${PUBLIC_URL}/assets/images/knaifel/cinema/02/1.jpg`}
        year="1978"
      />
      <Spacer half size={8} />
      <BlockCinema>
        <Spacer half size={4} />
        <SubTitle>«пишите, что хотите»</SubTitle>
        <Text>александр кнайфель:</Text>
        <>
          На одной из картин «Леннаучфильма» мы встретились с Алиакпером
          Гасан-Заде. Это мой дивный друг, потрясающий звукорежиссер, настоящий
          кинематографический мастер. Он записывал разные шумы, звуки природы,
          его всегда что-то не устраивало, он добивался высочайшего результата,
          все было штучным, единственным. Чего только мы с ним не записывали, а
          потом на «Ленфильме» возник проект про Чукотку. Автор сценария –
          чукотский писатель и поэт Юрий Рытхэу, режиссер – Георгий Кропачев,
          чудесный художник, работал с Козинцевым на «Гамлете», делал с Ершовым
          «Вий».
        </>
        <>
          И вот Кропачев решил снять фильм как режиссер. Для сценария Рытхэу
          взял мотивы из чукотского эпоса. Али замолвил за меня слово, и
          Кропачев одобрил мою кандидатуру, сказав: «Пишите, что хотите». И тут
          я нажал на акселератор! Смог воплотить все, что мне хотелось, это уже
          был настоящий опыт.
        </>
        <Spacer half size={4} />
        <SubTitle>идти путем истинной любви</SubTitle>
        <Spacer half size={4} />
        <Carousel
          autoHeight
          slides={[
            { url: `${PUBLIC_URL}/assets/images/knaifel/cinema/02/2.jpg` },
            { url: `${PUBLIC_URL}/assets/images/knaifel/cinema/02/3.jpg` },
          ]}
        />
        <Spacer half size={4} />
        <SubTitle>чистый лист, первобытный мир</SubTitle>
        <>
          Кропачев улетел с группой на мыс Провидения и там снимал. А это же не
          просто край земли, это уже то, где вообще ничего нет – ни времени, ни
          цивилизации. Снял изумительно. А потом не знал, что с этим материалом
          делать, как его монтировать – он этнографист, художник, но как
          режиссер он был совершенно беспомощен.
        </>
        <Spacer half size={4} />
        <Carousel
          autoHeight
          slides={[
            { url: `${PUBLIC_URL}/assets/images/knaifel/cinema/02/4.jpg` },
            { url: `${PUBLIC_URL}/assets/images/knaifel/cinema/02/5.jpg` },
            { url: `${PUBLIC_URL}/assets/images/knaifel/cinema/02/6.jpg` },
            { url: `${PUBLIC_URL}/assets/images/knaifel/cinema/02/7.jpg` },
            { url: `${PUBLIC_URL}/assets/images/knaifel/cinema/02/8.jpg` },
            { url: `${PUBLIC_URL}/assets/images/knaifel/cinema/02/9.jpg` },
          ]}
        />
        <Spacer half size={4} />
        <SubTitle>фильмофония</SubTitle>
        <>
          Мне же дали полный карт-бланш, да еще материал, который никаким
          образом не был связан ни с чем вообще, просто чистый лист, первородный
          мир – делай что хочешь. И у тебя даже инструментов нет, есть только
          голоса и первобытный барабан, и все, что из них можно извлечь.
        </>
        <>
          В итоге над всем царствовала фонограмма, все сидело на музыкальной
          подушке. Я это делал как цельную вещь, фильмофонию, которая называлась
          «Айнана», так звали героиню.
        </>
        <Spacer half size={4} />
        <SubTitle>я проснулся – белый снег, и я иду</SubTitle>
        <Spacer half size={4} />
        <Image
          alt="Александр Кнайфель"
          src={`${PUBLIC_URL}/assets/images/knaifel/cinema/02/10.jpg`}
        />
        <Spacer half size={4} />
        <>Это как раз Кропачев, его текст.</>
        <>
          В этой песенке есть все ключевые слова. Белоснежное поле – необозримый
          мир, белый и именно снежный. Любовь и надежда. И путь наугад – это
          единственно возможный и верный путь, потому что все остальные пути не
          имеют шансов. При этом путь без конца. Это все в словах
          незамысловатого детского напева. И этот образ, кстати, существует
          почти у всех народов, на разный лад.
        </>
        <>
          Помню, как у меня возникла эта
          <NBSP />
          <a
            href="https://music.yandex.ru/album/35413752/track/136149389"
            style={{
              borderBottom: "1px solid #ccc",
            }}
          >
            мелодия
          </a>
          : я на лыжах шел по бесконечному Финскому заливу. Я обожаю в марте там
          ходить, когда все заснеженное пространство сливается с небом. И нет
          горизонта. Иду и не знаю, куда я иду. То ли в небо, то ли...
          Проснулись утром – перед вами день, которого никогда и ни у кого не
          было. И ваша единственная задача – этот белоснежный путь пройти
          трепетно, осторожно, внимательнейше… Я проснулся – белый снег, и я
          иду.
        </>
        <Spacer half size={4} />
        <SubTitle>семнадцать вариаций на имя</SubTitle>
        <>
          Айнана – это чукотское имя, в нем три буквы «а», два «н» и одно «й». Я
          на основе этих числовых пропорций сделал вариации, всего семнадцать.
          Это было наитие!
        </>
        <Spacer half size={4} />
        <Image
          alt="Александр Кнайфель"
          src={`${PUBLIC_URL}/assets/images/knaifel/cinema/02/11.jpg`}
        />
        <Spacer half size={4} />
        <>
          В моем представлении, числа создают возможность истинной творческой
          свободы, чтобы попытаться в этом потоке, который несет в себе
          современный музыкальный язык, сориентироваться. И ловить то, что несет
          конкретный музыкальный момент.
        </>
        <Spacer half size={4} />
        <Image
          alt="Александр Кнайфель"
          src={`${PUBLIC_URL}/assets/images/knaifel/cinema/02/12.jpg`}
        />
        <Spacer half size={4} />
        <SubTitle>3-2-1</SubTitle>
        <>
          Поэтому в «Айнане» простейшая вещь – 3-1-2, количество букв в имени,
          но сочетание единицы, двойки и тройки в разных последовательностях
          сразу дает структурную свободу, чтобы почувствовав какой-то звуковой
          образ, попытаться его проявить. Все держится на таких вроде бы
          откровенно конкретных вещах, но ткань становится, благодаря этой
          конкретности, неуловимо органичной, живущей по собственным законам.
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/knaifel/source">[C—A]</Link>
          </sub>
        </>
        <Spacer half size={4} />
        <QuoteCinema>
          <QuoteCinemaText>георгий ковалевский:</QuoteCinemaText>
          <>
            Эти ряды, которые читаются и по горизонтали, и по вертикали,
            становятся основой для ритмических последовательностей. Каждая цифра
            обозначает размер, каждый такт написан в этом нерегулярном размере,
            возникает нерегулярная пульсация.
            <Spacer size={8} />
            <SubTitle>проверка слуховым опытом</SubTitle>
            <>
              У Кнайфеля научный подход, он все сознательно выписывает и
              комбинирует, а потом обязательно проверяет.
            </>
            <Spacer half size={2} />
            <>
              Слух является приемщиком-контроллером, за которым последнее слово.
              Если слух говорит, что что-то не так, значит, он идет другим
              путем, если все в порядке, значит дорога была найдена верно.
            </>
            <Spacer size={8} />
            <SubTitle>мелодия как животворящий дух</SubTitle>
            <>
              Мы видим шумовые, звуковые вещи, а на другом полюсе – живая
              мелодия.
            </>
            <Spacer half size={2} />
            <>
              Комбинаторика и числа – это все важно, но должна быть еще идея,
              некая вертикаль. И песня становится здесь этой идеей. «По
              белоснежному полю..» – белизна, которая в себя все вбирает. И
              вокруг этой идеи уже складывается все остальное.
              <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
                <Link to="/knaifel/source">[C—C]</Link>
              </sub>
            </>
          </>
        </QuoteCinema>
        <Spacer half size={4} />
        <Text>александр кнайфель:</Text>
        <>
          Инструменты, лежащие в организации музыки как таковой, в моем случае
          вот такие: числовые пропорции и графические партитуры.
        </>
        <Spacer half size={4} />
        <SubTitle>структурная основа импровизации</SubTitle>
        <>
          Я не могу импровизировать, когда нет за этим ничего, кроме наития. Мне
          это представляется изначально бесплодным. Должна быть основа любого
          дела, лучше структурная, которая обрела эту структуру благодаря
          каким-то более глубоким идеям или понятиям.
        </>
        <Spacer half size={4} />
        <Image
          alt="Александр Кнайфель"
          src={`${PUBLIC_URL}/assets/images/knaifel/cinema/02/13.jpg`}
        />
        <Spacer half size={4} />
        <SubTitle>как прорастающее растение</SubTitle>
        <>
          Возьмите этот квадрат, ведь можно было просто записать: давайте,
          ребята, дышите, кто как хочет. И отчасти так оно и происходило, потому
          что в режиме звукозаписи для кино нет времени углубляться в такие
          вещи, но я не могу себе позволить, я просто органически не могу этого
          вынести, я просто умру. А когда есть вот такая вещь, она точно не
          соблюдается и не может соблюдаться, но в ней есть зерно. Как
          прорастающее растение, оно может расти по своим непредсказуемым
          законам и вырасти по-разному, но оно все-таки вырастет сообразно
          заложенному в него главному. Тому, до чего мне нужно догадаться. А
          догадавшись, воплотить.{" "}
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/knaifel/source">[C—A]</Link>
          </sub>
        </>
        <Spacer half size={4} />
        <QuoteCinema>
          <SubTitle>каллиграф</SubTitle>
          <QuoteCinemaText>татьяна мелентьева:</QuoteCinemaText>
          <>
            Для него исключительно важна форма произведения, непозволительно
            вручать исполнителям некрасивую партитуру: отношение музыканта к
            нотному тексту – уже заявка на то, как он будет над этим работать и
            как относится. Поэтому он в каком-то смысле каллиграф.{" "}
            <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
              <Link to="/knaifel/source">[C—B]</Link>
            </sub>
          </>
        </QuoteCinema>
        <Spacer half size={4} />
        <SubTitle>пирамида голосов, батарея ударных и звериные рыки</SubTitle>
        <Text>александр кнайфель:</Text>
        <>
          Хор у меня в «Айнане» специфический. Одно сопрано пела Таня [Татьяна
          Мелентьева], в титрах оно исполнено детским голоском Аннушки
          [Кнайфель], два альта, три контральто, четыре тенора, пять баритонов и
          шесть басов. Такая
          <NBSP />
          <a
            href="https://music.yandex.ru/album/35413752/track/136149397"
            style={{
              borderBottom: "1px solid #ccc",
            }}
          >
            пирамида голосов
          </a>
          , под которой низкие ударные и магнитофонная лента с записью
          всевозможных эффектов, за которые отвечал Али.{" "}
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/knaifel/source">[C—A]</Link>
          </sub>
        </>
        <Spacer half size={4} />
        <QuoteCinema>
          <QuoteCinemaText>аркадий штейнлухт:</QuoteCinemaText>
          <>
            Замечательный звукорежиссер Али Гасан-Заде придумал необычный прием
            – двойную задержку звука. Он даже сделал специальный магнитофон с
            тремя звукозаписывающими головками, которые фиксировали звук три
            раза через доли секунды. Это придало всему звучанию необычную
            <NBSP />
            <a
              href="https://music.yandex.ru/album/35413752/track/136149390 "
              style={{
                borderBottom: "1px solid #ccc",
              }}
            >
              гулкость и фантастичность
            </a>
            .{" "}
            <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
              <Link to="/knaifel/source">[C—D]</Link>
            </sub>
          </>
        </QuoteCinema>
        <Spacer half size={4} />
        <Image
          alt="Александр Кнайфель"
          src={`${PUBLIC_URL}/assets/images/knaifel/cinema/02/14.jpg`}
        />
        <Spacer half size={4} />
        александр кнайфель:
        <>
          Певцов пригласили из Капеллы, дирижировал Аркадий Штейнлухт. Прихожу
          на запись в БТА [большое тон ателье] «Ленфильма», там у микрофонов
          пятнадцать мужиков, почтенных отцов семейств, пытаются извлечь
          выписанные мной «аэыиоу, оуаэыи…». Такие, понимаете, звериные рыки.
          Выглядело это, конечно, диковато. Помню, подумал: «Елки-палки,
          двенадцать ночи, чем они тут занимаются, за что я их так».
        </>
        <Spacer half size={4} />
        <Image
          alt="Александр Кнайфель"
          src={`${PUBLIC_URL}/assets/images/knaifel/cinema/02/15.jpg`}
        />
        <Spacer half size={4} />
        <SubTitle>дышащая планета</SubTitle>
        <>
          Все это было четко прописано в партитуре, непривычные выдохи-вдохи, в
          начале фонограмма состоит только из выдохов разной высоты, и создается
          особое пространство, словно дышащая планета.
        </>
        <>
          И это было очень искусно записано. Звукорежиссер понимал это и
          чувствовал.
        </>
        <Spacer half size={4} />
        <Image
          alt="Александр Кнайфель"
          src={`${PUBLIC_URL}/assets/images/knaifel/cinema/02/16.jpg`}
        />
        <Spacer half size={4} />
        <SubTitle>вселенская катастрофа в финале</SubTitle>
        <>
          В финале была вселенская катастрофа: нарастает в четыре раза
          замедленная фонограмма низких ударных, как гул Преисподней, а перед
          этим хор носится по студии, бьет во все мыслимое и немыслимое, вопит,
          кричит, свистит… Накапливается все пройденное, торжество любви и
          надежды завоевывает весь мир, а потом все проваливается... Так, как
          это и происходит веками. Божье порождение таит в себе неустранимую,
          вечно актуальную трагедию: мир, который обретает свою полноту, но при
          этом несется в бездну.
        </>
        <Spacer half size={4} />
        <Image
          alt="Александр Кнайфель"
          src={`${PUBLIC_URL}/assets/images/knaifel/cinema/02/17.jpg`}
        />
        <Spacer half size={4} />
        <SubTitle>итог</SubTitle>
        <>
          Когда «След росомахи» был завершен (первоначальная версия
          заканчивалась гибелью героев, падающих в пропасть, и в таком виде
          фильм пройти не мог), состоялся закрытый показ, на который пришел весь
          «Ленфильм», в том числе и видные мэтры. Пришли в основном из-за
          музыки, поскольку были наслышаны, что я делал в студии.
        </>
        <>
          Просмотр был в большом ленфильмовском зале с хорошим
          звуковоспроизведением. После этого студия просто на дыбы встала, мой
          дебют был очень шумным. Я помню, что меня после этого буквально в
          каждую редакторскую меня приглашали. А потом от картины ничего не
          осталось, ее стали резать: чтобы герои не погибли, чтобы того-сего не
          было.{" "}
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/knaifel/source">[C—A]</Link>
          </sub>
        </>
        <Spacer half size={4} />
        <QuoteCinema>
          <QuoteCinemaText>аркадий штейнлухт:</QuoteCinemaText>
          <>
            Фильм изгадили, превратили очень хорошую картину, едва ли не шедевр,
            в абсолютную пошлятину. Когда в Госкино посмотрели фильм, то
            сказали: «Нет, это не годится. Как это – молодой ученый погибает?
            Это плохо». Режиссер встал на дыбы, группа не получает потиражные,
            потому что фильм не выпускают. На него начали давить, он
            сопротивлялся сколько мог, но в какой-то момент сдался и
            перемонтировал фильм. А Рытхэу не вступился: кинулись к нему, чтобы
            он защитил своим авторитетом, но он этого не сделал.{" "}
            <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
              <Link to="/knaifel/source">[C—D]</Link>
            </sub>
          </>
        </QuoteCinema>
        <Spacer half size={4} />
        <Text>александр кнайфель:</Text>
        <>
          Фильм вышел, получил самую низшую категорию и очень быстро сошел с
          экранов.{" "}
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/knaifel/source">[C—A]</Link>
          </sub>
        </>
      </BlockCinema>

      {/* ---------------------------------------------------------- */}
      <Spacer size={15} />
      <FilmCover
        director="реж. болотбек шамшиев"
        name="«ранние журавли»"
        url={`${PUBLIC_URL}/assets/images/knaifel/cinema/03/1.jpg`}
        year="1979"
      />
      <Spacer half size={8} />
      <BlockCinema>
        <Spacer half size={4} />
        <SubTitle>шамшиев</SubTitle>
        <Text>александр кнайфель:</Text>
        <>
          Это была опять-таки большая инициатива Алиакпера Гасан-заде. Восточные
          люди. Шамшиев – киргиз, вместе с Шепитько учился во ВГИКе у Довженко.
          Он молодец, он настоящий, старой школой воспитанный, любящий детали,
          точность.
        </>
        <>
          Он перед этим делал фильм «Белый пароход» с Альфредом [Шнитке],
          который почему-то порекомендовал на эту картину меня, Альфред, видимо
          уже был сыт…
        </>
        <Spacer half size={4} />
        <Image
          alt="Александр Кнайфель"
          src={`${PUBLIC_URL}/assets/images/knaifel/cinema/03/2.jpg`}
        />
        <Spacer half size={4} />
        <SubTitle>цирк</SubTitle>
        <>
          В общем, Шамшиев приехал сюда, был на звукозаписи, пригласил меня во
          Фрунзе, теперь это Бишкек. Он считался в Киргизии живым классиком, был
          очень привередлив, и приглашение его я должен был расценивать как
          великую честь.
        </>
        <Spacer half size={4} />
        <Image
          alt="Александр Кнайфель"
          src={`${PUBLIC_URL}/assets/images/knaifel/cinema/03/3.jpg`}
        />
        <Spacer half size={4} />
        <>
          Приезжаю в Бишкек – огромный номер в гостинице, как вся квартира.
          Подхожу с чемоданом к окну, в окне крутится надпись – «Цирк». А это
          все для меня… я как Буратино, если вижу цирк, меня уже ничто не может
          остановить. Мое глубокое убеждение, что есть три кита, на которых
          строится вся земная жизнь: цирк, футбол и джаз. Убрать любое
          составляющее невозможно, потому что это все – абсолютно чистые вещи.
        </>
        <>
          В этот момент Шамшиев, король, царь, появляется в гостинице с целой
          свитой и с цветами, с подарками, я не знаю, с чем еще. «Композитор
          прилетел?» – «Композитор прилетел». – «Где он?» – «Композитор в
          цирке». Говорят, что это надо было снимать на пленку, он на два дня
          вообще выпал.
        </>
        <Spacer half size={4} />
        <SubTitle>народный композитор киргизии</SubTitle>
        <>
          Встретился со мной, повез меня в горы. Тогда у меня уже стала звучать
          первая тема – прощальная песня человека, который уходит на войну и
          оставляет детей.{" "}
        </>
        <>
          Если на фильме «След росомахи» было царствие свободы, то здесь сразу
          же – Шамшиев, строго воспитанный в своей школе и с его репутацией
          диктатора. А я был все-таки достаточно неотесанный, не так много
          опыта, и я чувствовал это давление, с одной стороны, а с другой –
          ответственность перед конкретным фольклором и культурной средой.{" "}
        </>
        <>
          И поэтому, когда я написал эту прощальную песню, для меня было
          поразительно, что они это восприняли как свое, как вполне народную
          мелодию. Здесь уже был не Рытхэу, здесь был Айтматов, и, когда песня
          была написана, он ее тоже стал подтекстовывать. Так что я оказался
          народным композитором Чукотки, а потом и Киргизии сразу.
        </>

        <Spacer half size={4} />
        <SubTitle>три крыла</SubTitle>
        <>
          Вообще в моем представлении вся музыка к этому фильму называется
          <NBSP />
          <a
            href="https://music.yandex.ru/album/35413752/track/136149391"
            style={{
              borderBottom: "1px solid #ccc",
            }}
          >
            «Три крыла»
          </a>
          , то есть три исходных темы. Одна, которой я очень горжусь, и
          по-прежнему считаю лучшей темой в мировом кинематографе, прости,
          Господи. Ее можно поставить в любой фильм любого времени любой страны.
        </>
        <>
          Вторая – это народная, «Эсимде» (в переводе – «помню каждый прожитый
          миг». – примеч. авт.), изумительная, бесконечная мелодия, у которой ни
          начала, ни края, – вся построена на нисходящих тонах. Вьется
          прихотливо, и мне страшно важно было это качество: вроде бы
          прихотливо, а с другой стороны – единственно возможным образом.
        </>
        <>И вот эта прощальная песня.</>
        <>
          С музыкальной точки зрения их объединяет натуральный минор. И я
          обыгрывал это таким образом, чтобы все три мелодии друг в друга
          проникали, шли в одних долях, ритм одной переходил в тему другой,
          чтобы они создали целый организм. И это было возможно на основе
          единства звукоряда. Поэтому три крыла. Они как полет.
        </>
        <Spacer half size={4} />
        <Image
          alt="Александр Кнайфель"
          src={`${PUBLIC_URL}/assets/images/knaifel/cinema/03/4.jpg`}
        />
        <Spacer half size={4} />
        <SubTitle>и знает, и чувствует, и слышит</SubTitle>
        <>
          А дирижер у меня постоянный был и остается – Аркадий Матвеевич
          Штейнлухт. Это дирижер Божьей милостью. Он и знает, и чувствует, и
          слышит – все изумительно. Кроме того, у него силы нечеловеческие, и
          совершенно фантастическое чувство ритма. Знаете, есть метроном?
          Тик-тик. Вот вы его спросите: «Какой темп?» Он напряжется, и точно
          скажет: «73». Это невозможно, а он может.
        </>
        <>
          Большинство фильмов я с ним сделал и по-прежнему работаю с ним над
          всеми своими фонограммами.{" "}
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/knaifel/source">[C—A]</Link>
          </sub>
        </>
        <Spacer half size={4} />
        <Image
          alt="Александр Кнайфель"
          src={`${PUBLIC_URL}/assets/images/knaifel/cinema/03/5.jpg`}
        />
        <Spacer half size={4} />
        <QuoteCinema>
          <QuoteCinemaText>аркадий штейнлухт:</QuoteCinemaText>
          <>
            В «Ранних журавлях» не было большого оркестра, там были всякие
            экзотические инструменты: чимбаса, басовый тромбон, его взяли из
            Малого оперного… Один номер нужно было сыграть на тимпани, очень
            нежно. Мы перепробовали все палки, которые были у ударника, и
            кончилось тем, что я сыграл не палками, а пальцами.{" "}
            <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
              <Link to="/knaifel/source">[C—D]</Link>
            </sub>
          </>
        </QuoteCinema>
        <Spacer half size={4} />
        <Text>александр кнайфель:</Text>
        <>
          ...а еще труба-пикколо. Малков, трубач, был у Мравинского, брал очень
          высокие ноты, буквально через месяц после записи улетел навсегда в
          Америку. И басовая труба, фактически тромбон по звучанию, на нем играл
          знаменитый тромбонист Венгловский из оркестра Мравинского. Все это
          зафиксировано. И под экран писали. Такая пронзительная партитура.{" "}
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/knaifel/source">[B—C]</Link>
          </sub>
        </>
        <Spacer half size={4} />
        <Image
          alt="Александр Кнайфель"
          src={`${PUBLIC_URL}/assets/images/knaifel/cinema/03/6.jpg`}
        />
        <Spacer half size={4} />
        <SubTitle>испытание</SubTitle>
        <>
          Это единственная моя работа в кино, где, по-моему, 45 номеров. И
          никуда не рыпнуться. Потому что там была другая эстетика, и я, кстати,
          очень благодарен, что хотя бы раз этого коснулся. А во всех остальных
          случаях делал то, что мне было нужно.
        </>
        <>
          Главное, что фильм хорошо шел на экранах, и музыка в нем звучала
          нормально. Но больше я с Шамшиевым не работал. Даже не знаю, что он
          потом делал.{" "}
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/knaifel/source">[C—A]</Link>
          </sub>
        </>
      </BlockCinema>

      {/* ---------------------------------------------------------- */}
      <Spacer size={15} />
      <FilmCover
        director="реж. семен аранович"
        name="«рафферти»"
        url={`${PUBLIC_URL}/assets/images/knaifel/cinema/04/1.jpg`}
        year="1980"
      />
      <Spacer half size={8} />
      <BlockCinema>
        <SubTitle>аранович</SubTitle>
        <Text>александр кнайфель:</Text>
        <>
          На «Ленфильме», когда случился мой дебют, стали меня таскать, схватили
          за ручки белые и водили во все съемочные группы. В общем, шум был
          невероятный.
        </>
        <>
          И вот буфет «Ленфильма», сидят все, и я сижу, но, видимо, было все
          подстроено: «А вы знаете Семена Арановича?» – «Да, я что-то слышал». И
          тут же из-за соседнего столика он сам разворачивается.
        </>
        <Spacer half size={4} />
        <Image
          alt="Александр Кнайфель"
          src={`${PUBLIC_URL}/assets/images/knaifel/cinema/04/2.jpg`}
        />
        <Spacer half size={4} />
        <>
          Это была наша первая встреча, а после он кинулся головой в омут –
          пригласил меня писать музыку.
        </>
        <Spacer half size={4} />
        <SubTitle>танго</SubTitle>
        <>
          Мне сразу показали ключевой эпизод. Я сказал: «Здесь будет танго». –
          «Ах, танго», – всем это очень понравилось.
        </>
        <>
          Я Арановичу ничего предварительно не играл, пришли на запись и прямо с
          этого начали: первое, что он услышал, было титровое танго. Он просто
          взвился до небес. Это было невероятное для меня зрелище, как он влетел
          с выпученными глазами. Стал мне что-то предлагать, хотел уже
          участвовать как композитор: «Здесь добавим, тут добавим!» И с этого
          все началось.
        </>

        <Spacer half size={4} />
        <SubTitle>живой отклик</SubTitle>
        <>
          А потом ему без конца писали письма: «Мы смотрим картину для того,
          чтобы послушать танго к финальным титрам». Аранович совершенно не
          обижался, наоборот, был счастлив. Меня же после «Рафферти» котлетами
          даровыми кормили в домах творчества! Вы понимаете, любили меня люди!
          Вы не представляете себе, какое это неизведанное чувство. Мою музыку в
          кабаках играли, даже издали ноты в сборнике популярных мелодий, в
          облегченном переложении для любителей.
        </>

        <Spacer half size={4} />
        <SubTitle>радость, свобода и независимость</SubTitle>
        <>
          Деньги были такие, что год точно можно было жить, а может, и полтора.
          Спокойно, хорошо жить. А потом была же еще и потиражная система, все
          это обеспечивало существование, я ни о чем не беспокоился. Главное,
          что у меня было ощущение, что могу. Ведь у меня были очень объемные и
          невероятно сложные основные работы. И для них мне нужно было много
          свободного времени и независимость ни от кого. Во-первых, а во-вторых,
          это приносило столько радости!
        </>
        <Spacer half size={4} />
        <Image
          alt="Александр Кнайфель"
          src={`${PUBLIC_URL}/assets/images/knaifel/cinema/04/3.jpg`}
        />
        <Spacer half size={4} />
        <SubTitle>никогда не было халтурой</SubTitle>
        <>
          Я же знаю, и для Альфреда [Шнитке], и для всех моих друзей, которые
          работали параллельно в кино, для них это, в общем, всегда была
          халтура, заработок, они так это и называли. Или Шостакович. А для меня
          это никогда халтурой не было. Все заказы, которые я когда-либо делал,
          оформлял своими же замыслами.
        </>
        <>
          У меня нет принципиально никакого разделения между тем, что я делал на
          киностудии, и за ее пределами. Это было органически продолжением
          одного и того же.
        </>

        <Spacer half size={4} />
        <SubTitle>с какой стати я?</SubTitle>
        <>
          У меня был невероятно жадный интерес: «С какой стати я?» Ведь я
          никогда не занимался впрямую джазом, но, когда возник «Рафферти», а
          это американская история, я вошел в эту стихию, в которую просто так
          не войдешь.
        </>

        <Spacer half size={4} />
        <SubTitle>стать другим человеком</SubTitle>
        <>
          Нужно было стать на какое-то время другим человеком. Я занырнул в
          джаз, и это было мучительно. С нуля стал осваивать основы блюзовой
          гармонии, тактирования, структуры.
        </>
        <>
          В результате на записи, я как будто с ними и жил. И ни до, ни после
          больше этого не было.
        </>

        <Spacer half size={4} />
        <SubTitle>наглость</SubTitle>
        <>
          Арановичу было интересно предательство и все, что с ним связано. Там
          царствовал Борисов, он же гений, это просто титан, и на нем все
          держалось. В фильме отправная точка – это
          <NBSP />
          <a
            href="https://music.yandex.ru/album/35413752/track/136149392"
            style={{
              borderBottom: "1px solid #ccc",
            }}
          >
            танго
          </a>
          , когда он танцует. На запись явился Анатолий Вапиров, знаменитый
          тогда саксофонист, я почувствовал, что в нем есть то, что нужно, –
          наглость, у саксофона в принципе это есть, а тут я хотел, чтобы и
          исполнитель тоже был такой. А это его характер: когда он хватал
          саксофон, в нем эта наглость просто сквозила.
        </>
        <>
          Он приходит и говорит: «А как вы будете работать, вы же джазом никогда
          не занимались! Вы же ничего не знаете об этом». – «Да, но вот
          работаю». – «А кто это будет петь?» – «Моя жена». – «Но она
          классическая певица, как она будет свинговать?» – «Попробуем».{" "}
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/knaifel/source">[C—A]</Link>
          </sub>
        </>
        <Spacer half size={4} />
        <QuoteCinema>
          <QuoteCinemaText>
            георгий ковалевский (комментарий к партитуре):
          </QuoteCinemaText>
          <>
            В имени Рафферти он находит музыкальные звуки, равные названиям нот.
            А дальше составляет тему и присваивает ее герою. Составляет
            мелодические ячейки к имени каждого из героев. Находит тоны, которые
            звучат, и составляет мелодии.{" "}
            <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
              <Link to="/knaifel/source">[C—C]</Link>
            </sub>
          </>
        </QuoteCinema>
        <Spacer half size={4} />
        <Image
          alt="Александр Кнайфель"
          src={`${PUBLIC_URL}/assets/images/knaifel/cinema/04/4.jpg`}
        />
        <Spacer half size={4} />
        <SubTitle>самая главная музыка</SubTitle>
        <Text>александр кнайфель:</Text>
        <>
          С танго еще туда-сюда, но блюз! Исконный джазовый блюз с его свингом,
          с его гармонией, с его особым течением, с его ощущением – это вся
          суть, которая определяет джаз как таковой. Когда Вапиров спросил меня
          об этом, я понимал, что по-своему он прав, но вопрос как-то исчез,
          когда я впервые услышал свой
          <NBSP />
          <a
            href="https://music.yandex.ru/album/35413752/track/136149398"
            style={{
              borderBottom: "1px solid #ccc",
            }}
          >
            блюз
          </a>
          <NBSP />в живом звучании. Я настолько был сам потрясен, что мне уже
          было не до фильма, и не до Арановича, и вообще ни до чего.{" "}
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/knaifel/source">[C—A]</Link>
          </sub>
        </>
        <Spacer half size={4} />
        <Image
          alt="Александр Кнайфель"
          src={`${PUBLIC_URL}/assets/images/knaifel/cinema/04/5.jpeg`}
        />
        <Spacer half size={4} />
        <>
          [С киномузыкой] во мне сразу же раскрылись возможности, материки и
          государства с разными стилями, необходимость их освоить.{" "}
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/knaifel/source">[B—C]</Link>
          </sub>
        </>
      </BlockCinema>

      {/* ---------------------------------------------------------- */}
      <Spacer size={15} />
      <FilmCover
        director="реж. виктор соколов"
        name="«я – актриса»"
        url={`${PUBLIC_URL}/assets/images/knaifel/cinema/05/1.jpg`}
        year="1980"
      />
      <Spacer half size={8} />
      <BlockCinema>
        <Spacer half size={4} />
        <SubTitle>все красиво, а картины нет</SubTitle>
        <Text>александр кнайфель:</Text>
        <>
          Поразительно, что одновременно с «Рафферти» – это все было эхом моего
          дебюта – я писал музыку к фильму про Веру Комиссаржевскую. Работал для
          совершенно взаимоисключающих фильмов. Соколов – артистичный, красиво
          снимал Наташу Сайко. Там красота и такая, и сякая – фильма нет, но
          каждым кадром любоваться можно.
        </>
        <Spacer half size={4} />
        <Image
          alt="Александр Кнайфель"
          src={`${PUBLIC_URL}/assets/images/knaifel/cinema/05/2.jpg`}
        />
        <Spacer half size={4} />
        <>
          И параллельно с этим в соседнем зале идет такое вот черно-белое:
          беспощадный, жестокий фильм «Рафферти». Так что у меня почти
          одновременно уживались XIX век и джаз. Мне было интересно вписаться в
          разные пласты культуры.
        </>

        <Spacer half size={4} />
        <SubTitle>соколов</SubTitle>
        <>
          Он [Соколов] был очень музыкальный человек, жена – балерина. Я все
          сделал в стилистике XIX века… И Комиссаржевская, как образ всего
          этого.{" "}
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/knaifel/source">[C—A]</Link>
          </sub>
        </>
        <Spacer half size={4} />
        <Image
          alt="Александр Кнайфель"
          src={`${PUBLIC_URL}/assets/images/knaifel/cinema/05/3.jpg`}
        />
        <Spacer half size={4} />
        <QuoteCinema>
          <QuoteCinemaText>виктор соколов, режиссер:</QuoteCinemaText>
          <>
            …Главное, к чему мы тогда пришли, было то, что
            <NBSP />
            <i>фильм должен быть о Душе Художника</i>. Мы выбросили даже остатки
            сценарных любовных перипетий. В самой жизни Комиссаржевской было
            много любви, театральности. Настоящий символизм в духе времени…{" "}
            <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
              <Link to="/knaifel/source">[D—A]</Link>
            </sub>
          </>
        </QuoteCinema>
        <Spacer half size={4} />
        <SubTitle>без связи с сюжетом</SubTitle>
        <Text>александр кнайфель:</Text>
        <>
          Там в музыке хоралы, монологи, но я их писал без всякой связи с
          сюжетом. Их могли поставить туда, могли поставить сюда. И так же как с
          Арановичем, было много случаев, когда из-за музыки меняли монтаж. А
          когда не знали, что делать, включали десятиминутный фрагмент –
          фильмофон – и были счастливы. Безнадежная ситуация – и вот вроде
          ничего.{" "}
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/knaifel/source">[C—A]</Link>
          </sub>
        </>

        <Spacer half size={4} />
        <SubTitle>музыка вне фильма</SubTitle>
        <>
          Я всегда сочинял музыку с расчетом на то, чтобы она могла существовать
          и вне фильма, чтобы она превосходила его по своей сути. У меня даже
          были случаи, когда замысел музыки возникал прежде, чем появлялся заказ
          в кино.{" "}
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/knaifel/source">[B—B]</Link>
          </sub>
        </>
        <Spacer half size={4} />
        <QuoteCinema>
          <QuoteCinemaText>аркадий штейнлухт:</QuoteCinemaText>
          <>
            Это была колоссальная работа в Капелле с оркестром Мариинского
            театра. Не все записанное вошло в фильм, хотя музыка очень красивая.
            Вот
            <NBSP />
            {/* Вот<NBSP /> */}
            <a
              href="https://music.yandex.ru/album/35413752/track/136149396"
              style={{
                borderBottom: "1px solid #ccc",
              }}
            >
              «Строфа посвящения»
            </a>
            <NBSP />
            живет отдельной жизнью, даже исполнялась на ВВС, но только она.{" "}
            <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
              <Link to="/knaifel/source">[C—D]</Link>
            </sub>
          </>
        </QuoteCinema>
        <Spacer half size={4} />
      </BlockCinema>

      {/* ---------------------------------------------------------- */}
      <Spacer size={15} />
      <FilmCover
        director="реж. семен аранович"
        name="«торпедоносцы»"
        url={`${PUBLIC_URL}/assets/images/knaifel/cinema/06/1.jpg`}
        year="1983"
      />
      <Spacer half size={8} />
      <BlockCinema>
        <SubTitle>некрасивая история</SubTitle>
        <Text>александр кнайфель:</Text>
        <>
          Там была история очень некрасивая. Герман стал упрекать Арановича, что
          он взял себе всех его актеров, всю съемочную группу. Хотя лично я на
          перезаписи видел, как Кармалита приходила и чувствовала, что картина
          явно получается шедевром: «Семен, ну государушку мне нужно».
          Понимаете, что это? Государственная премия. Это был ее сценарий по
          рассказам Юрия Германа.{" "}
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/knaifel/source">[C—A]</Link>
          </sub>
        </>
        <Spacer half size={4} />
        <QuoteCinema>
          <QuoteCinemaText>любовь аркус:</QuoteCinemaText>
          <>
            В это время у Германа на полке лежит «Лапшин», где очень важное
            значение имеет то, что зрители не знают актеров. Ни Болтнева, ни
            Жаркова, ни Сашу Филиппенко. Там были никому не известные актеры,
            которых второй режиссер [Виктор] Аристов получил задачу найти. И он
            ездил по всем провинциальным театрам и смотрел людей. Везде искал –
            и в Москве, и в Петербурге. Герман открывает совершенно новых
            актеров, которые потрясающе играют, и для него это было важно. Что
            делает Аранович? Он всех этих актеров берет в «Торпедоносцы» по
            сценарию Германа. А дальше – шумный кассовый успех, государственная
            премия.{" "}
            <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
              <Link to="/knaifel/source">[C—E]</Link>
            </sub>
          </>
        </QuoteCinema>
        <Spacer half size={4} />
        <QuoteCinema>
          <SubTitle>ребята, отдайте это мне</SubTitle>
          <QuoteCinemaText>алексей герман, режиссер:</QuoteCinemaText>
          <>
            Этот сценарий мы со Светланой вообще-то писали для меня. Писали
            очень долго. Был еще разгар брежневских времен. Картина вышла в
            начале 1980-х, Светка получила Госпремию, и буквально через два года
            начали выпускать мои старые фильмы. Когда сценарий «Торпедоносцев»
            был написан, к нам пришел Семен Аранович. Он был очень хороший
            рассказчик, очень обаятелен, страшно любим женщинами. До того как
            прийти на «Ленфильм», снимал документальное кино, а до этого был
            летчиком. Старший лейтенант, штурман. Более того, он летал на Севере
            и все эти аэродромы хорошо знал. А после войны поступил во ВГИК. Мы
            дали почитать ему сценарий – нет ли ошибок. Он же нам сказал:
            «Ребята, вы себе напишете такой же. Отдайте этот мне! Я же летчик… Я
            все это знаю, летал на ИЛе. Я сниму». Мы поговорили-поговорили и
            решили отдать ему.{" "}
            <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
              <Link to="/knaifel/source">[C—E]</Link>
            </sub>
          </>
        </QuoteCinema>
        <Spacer half size={4} />
        <Image
          alt="Александр Кнайфель"
          src={`${PUBLIC_URL}/assets/images/knaifel/cinema/06/2.jpg`}
        />
        <Spacer half size={4} />
        <QuoteCinema>
          <SubTitle>возьми моих артистов</SubTitle>
          <QuoteCinemaText>алексей герман, режиссер:</QuoteCinemaText>
          <>
            Аранович взял моих артистов. Они год летали ко мне на съемки, а
            теперь в своих провинциальных театрах считались посмешищем. Что мне
            с ними делать? Я пришел к Арановичу и говорю: «Семен, это наш
            сценарий – возьми моих артистов! Мне невыносимо, что над ними будут
            смеяться».
          </>
          <Spacer half size={2} />
          <>
            Я ему помогал с этой картиной во всем. Каждый вечер мы с ним сидели
            с «Торпедоносцами». Потом Аранович взялся за сериал
            [«Противостояние»] с моими артистами, даже в костюмах из «Лапшина».
            Мы тогда как раз поссорились, и я думаю: выйдет его сериал с моими
            артистами, а «Лапшина» никто не видел. Моего открытия артистов будто
            бы и нет. Тогда вдруг боженька пришел мне на помощь. Сериал этот по
            Юлиану Семенову неожиданно положили на полку. И выскакивает «Лапшин»
            – семь копий, которые мне дал Андропов! А дальше рассказывайте про
            меня, что хотите.{" "}
            <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
              <Link to="/knaifel/source">[D—D]</Link>
            </sub>
          </>
        </QuoteCinema>
        <Spacer half size={4} />
        <SubTitle>как скрипят сапоги</SubTitle>
        <Text>александр кнайфель:</Text>
        <>
          Дело в том, что кроме Арановича так снять никто не мог. Потому что он
          профессиональный летчик, он все это через свою шкуру пропустил, для
          него каждая деталь важна. Я помню конфликт, крики на всю студию; на
          «Ленфильме» была звукооператор Галя Лукина – хороший оператор, но она
          женщина.. Понимаете, взбирается человек на обледенелое крыло самолета,
          Аранович знает, как скрипят сапоги в этот момент, а она не знает...
          Три дня они не разговаривали. Я его понимаю, для него это все кровное.
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/knaifel/source">[C—A]</Link>
          </sub>
        </>
        <Spacer half size={4} />
        <Image
          alt="Александр Кнайфель"
          src={`${PUBLIC_URL}/assets/images/knaifel/cinema/06/3.jpg`}
        />
        <Spacer half size={4} />
        <QuoteCinema>
          <SubTitle>где взяли немецкие корабли</SubTitle>
          <QuoteCinemaText>семен аранович, режиссер:</QuoteCinemaText>
          <>
            В режиссерском сценарии я делал специальные пометки для съемочной
            группы: в хронике стремиться к «художественности», а в игровом
            материале – к хроникальности, отсюда – отсутствие крупных планов,
            деталей и т.п. Мы пытались таким образом сделать незаметными стыки
            нашего материала с реальными военными кадрами. Кажется, это нам
            удалось: меня нередко спрашивают и о том, где мы взяли немецкие
            корабли и немецкую корабельную артиллерию времен войны (это
            хроника!), и наоборот, как нам удалось вмонтировать лица современных
            актеров в хроникальные кадры торпедных атак (это были полностью
            игровые, снятые нами эпизоды).{" "}
            <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
              <Link to="/knaifel/source">[E—A]</Link>
            </sub>
          </>
        </QuoteCinema>
        <Spacer half size={4} />
        <SubTitle>мне нужна не музыка кадра, мне нужна музыка фильма</SubTitle>
        <Text>александр кнайфель:</Text>
        <>
          Я подключился к картине, когда готовилась большая экспедиция на Север.
          На съемках я не бывал никогда. Более того, Аранович никогда ничего не
          просил – мне было всегда неуютно, из-за того, что ничего нельзя ему
          показать предварительно. «Вот на записи сделай» – это его
          интересовало, а всякие эскизы, обсуждения – ничего. Мы никогда не
          писали под экран. Он говорил: «Мне нужна не музыка кадра, мне нужна
          музыка фильма».
        </>
        <Spacer half size={4} />
        <Image
          alt="Александр Кнайфель"
          src={`${PUBLIC_URL}/assets/images/knaifel/cinema/06/4.jpg`}
        />
        <Spacer half size={4} />
        <SubTitle>американский фокстрот и православная молитва</SubTitle>
        <>
          Для обсуждения на худсовете заявки – все-таки эта картина, требующая
          больших затрат, северная экспедиция – Аранович выбрал два музыкальных
          ориентира: популярный американский фокстрот и православную молитву.
          Картине нужна индивидуальная сетка, чтобы забросить и очертить сферы,
          в которых она должна звучать. И первое, что я сделал, две стилизации –
          <NBSP />
          <a
            href="https://music.yandex.ru/album/35413752/track/136149403"
            style={{
              borderBottom: "1px solid #ccc",
            }}
          >
            «Фокстрот»
          </a>
          <NBSP />и «Молитва». И то, и другое не вошло. Изменился сам фильм.
        </>
        <>
          А сама по себе фонограмма эта мне была очень дорога, потому что там
          есть точно сделанные вещи, свидетельство эпохи. В стилистику фокстрота
          нужно было зайти и с ним какое-то время пожить, так же как это было с
          танго [в «Рафферти»]. Но эта фонограмма звучит только в облегчённом
          варианте, в одном маленьком эпизоде.
        </>
        <Spacer half size={4} />
        <SubTitle>в наследство от каравайчука</SubTitle>
        <>
          Кроме этого, я сделал фонограмму, которая называлась «Дагерротип». Там
          я впервые обнаружил свой любимый инструмент – расстроенный рояль.
          Достался он мне в наследство от Олега Каравайчука. Я и с Арановичем
          встретился благодаря их временному разрыву.
        </>
        <Spacer half size={4} />
        <SubTitle>сломанный рояль</SubTitle>
        <>
          И вот на «Ленфильме» в «Торпедоносцах» мне прислышалось звучание
          расстроенного рояля, а расстраивать его – это сложная и кропотливая
          работа. Обычно у одной ноты три струны: левая из них опускается вниз,
          средняя остаётся в тоне, правая – чуть выше. Для инструмента это
          вредно – а что делать, нужно записывать. Идея есть, ноты есть, а что
          дальше – никто толком не знает, и где мы его возьмём, этот рояль? И
          тут кто-то: «Слушайте, тут уже полтора года как Каравайчук сломал
          рояль, и вот он лежит без ножек на полу, весь в пыли».{" "}
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/knaifel/source">[C—A]</Link>
          </sub>
        </>
        <Spacer half size={4} />
        <QuoteCinema>
          <SubTitle>щемящая нота</SubTitle>
          <QuoteCinemaText>аркадий штейнлухт:</QuoteCinemaText>
          <>
            Началось с того, что мы приехали вместе с Шуриком в студию задолго
            до начала записи. У него был настроечный ключ. В студии стояло два
            рояля: один в нормальном строе, а другой каравайчуковский, на
            полтона или на тон даже ниже. И мы этот рояль расстроили. Каждую
            струну чуть-чуть опускали, проверяли, не слишком ли много, именно
            чуть-чуть, чтобы осталось такое дребезжание. Это щемящая нота,
            которую на обычном рояле воссоздать невозможно. Этот номер
            пронизывает весь фильм, как будто голос болит. Гениальный Аранович,
            он из всех фонограмм вытянул этот номер. И практически весь фильм он
            звучит.{" "}
            <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
              <Link to="/knaifel/source">[C—D]</Link>
            </sub>
          </>
        </QuoteCinema>
        <SubTitle>абсолютный резонанс</SubTitle>
        <Text>александр кнайфель:</Text>
        <>
          Часто бывает, если музыка в правильном резонансе, выявляются какие-то
          важные вещи – в итоге этот абсолютный резонанс все и решает. Это не
          мое, я этого не придумываю, но, когда попадаю на след, он начинает
          меня нести.{" "}
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/knaifel/source">[C—A]</Link>
          </sub>
        </>
        <SourceText>
          Музыка не сочиняется, а обнаруживается!
          <br />
          (дневник)
          <br />
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            [E—I]
          </sub>
        </SourceText>
        <Spacer half size={4} />
        <Image
          alt="Александр Кнайфель"
          src={`${PUBLIC_URL}/assets/images/knaifel/cinema/06/5.jpg`}
        />
        <Spacer half size={4} />
        <SubTitle>пораненность</SubTitle>
        <>
          Эта фонограмма сразу же легла, причем на все эпизоды, определив
          звучание картины –<NBSP />
          <a
            href="https://music.yandex.ru/album/35413752/track/136149400"
            style={{
              borderBottom: "1px solid #ccc",
            }}
          >
            пронзительное и чуть надтреснутое
          </a>
          .{" "}
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/knaifel/source">[C—A]</Link>
          </sub>
        </>
        <Spacer half size={4} />
        <SubTitle>купить приличный рояль</SubTitle>
        <>
          После просмотра случилась овация. Однако не подозревал я, что вместе с
          роялем расстроил и директора студии. «Мы на пороге Государственной
          премии, – поздравил возбужденно он музыкального редактора, – а наша
          орденоносная студия – что! – совсем не в состоянии купить приличный
          рояль?!»{" "}
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/knaifel/source">[B—D]</Link>
          </sub>
        </>
        <Spacer half size={4} />
        <SubTitle>вяжущая фонограмма</SubTitle>
        <>
          Еще один номер, который был записан, растворился в сумасшедшей
          фонограмме воздушных боев. Там невероятное количество шумов: взрывы,
          моторы, лязги гильз, топот ног. И поперек всего этого звучит вяжущая
          фонограмма, которая заворачивает все в особую фантасмагорию. Как
          Аранович это сделал! Это классика, на уровне Эйзенштейна.
        </>
        <Spacer half size={4} />
        <SubTitle>феликсон</SubTitle>
        <>
          В моей мастерской висит инструмент – феликсон. Его сделал абсолютно
          гениальный мастер, Феликс Равдоникас. Как Менделеев создал
          Периодическую систему, так он поступил со звуком – разработал теорию
          звукового поля. А на ранней стадии он изобретал, делал старые
          ренессансные инструменты. И этот он придумал специально для меня,
          такого инструмента не существует в природе. Латунный лист, на который
          в определенных, только ему известных местах навинчены латунные
          стержни, на них играют виолончельным смычком. Звучание просто
          космическое, никакая электроника не сравнится. Впервые мы его
          опробовали как раз на «Торпедоносцах» в фонограмме боев.{" "}
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/knaifel/source">[C—A]</Link>
          </sub>
        </>
        <Spacer half size={4} />
        <Image
          alt="Александр Кнайфель"
          src={`${PUBLIC_URL}/assets/images/knaifel/cinema/06/6.jpg`}
        />
        <Spacer half size={4} />
        <SubTitle>из ничего</SubTitle>
        <>
          В фильме есть потрясающая сцена на пристани, когда провожают корабль,
          который потом разбомбят. Такое житейское: собираются с чемоданами,
          идут, старые люди, молодые, дети пищат, старушку ведут, зонтик
          вырвался и плавает на воде. Немыслимое количество деталей – аура
          совершенно невероятная, которую снять невозможно. Аранович всегда
          сидел на звуке, уже не перезаписи – он не доверял это никому. И вот
          тут он всегда начинал колдовать.
        </>
        <Spacer half size={4} />
        <Image
          alt="Александр Кнайфель"
          src={`${PUBLIC_URL}/assets/images/knaifel/cinema/06/7.jpg`}
        />
        <Spacer half size={4} />
        <>
          Когда у него была под рукой вся звуковая палитра и он начинал
          работать, например, над этой сценой, на глазах из ничего – вот одна
          материя, вот другая – вдруг все складывалось в такое, что представить
          себе невозможно. И я помню, как он говорил: «Я в кинематографе столько
          лет, но до сих пор не пойму, что это за чудо – кино, из чего оно
          добывается, и как возникает». Это суть любого искусства, вот ничего
          нет – и вдруг возникает такая данность, которую невозможно было
          представить. И музыка, в данном случае – она пахла!
        </>
        <Spacer half size={4} />
        <SubTitle>догадаться</SubTitle>
        <>
          Отснятого материала я не видел, искал основной смысл. И это во всех
          фильмах так. Любая картина несет какой-то ракурс, даже ракурсы.
          Понимаете, куст пахнет. Мне надо догадаться, какой у него запах. И
          если этот запах угадаешь, он будет работать. Для кино больше ничего не
          нужно.
        </>
        <>
          Конкретный фильм может быть частным случаем какого-то ракурса или
          проблемы. Частным. А мне нужно нащупать саму проблему. Мне нужно
          схватить принципиальную суть ракурса, пространства, неповторимость.
        </>

        <Spacer half size={4} />
        <SubTitle>в бесчисленном количестве измерений</SubTitle>
        <>
          Тут очень важная вещь: я знаю очень много художников, поэтов,
          композиторов – они находятся в коме, живут в одном измерении.
          Невероятно талантливые, одаренные, но измерение одно, даже не два. А
          мы должны жить не только в трех-четырех, но в бесчисленном количестве
          измерений, о которых мы даже не знаем. И это главное. Тогда отпадает
          вопрос дара – если тебя все касается и ты являешься частью всего…
          Поэтому я и стал человеком кино.{" "}
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/knaifel/source">[C—A]</Link>
          </sub>
        </>
      </BlockCinema>

      {/* ---------------------------------------------------------- */}
      <Spacer size={15} />
      <FilmCover
        director="реж. семен аранович"
        name="«противостояние»"
        url={`${PUBLIC_URL}/assets/images/knaifel/cinema/07/1.jpg`}
        year="1985"
      />
      <Spacer half size={8} />
      <BlockCinema>
        <SubTitle>действовать напрямую</SubTitle>
        <Text>александр кнайфель:</Text>
        <>
          Когда нужно было писать музыку к «Противостоянию», я отлично понимал,
          что это знаковый момент – у всех в памяти еще был сериал «Семнадцать
          мгновений весны», когда вся страна стояла на ушах, а тут, практически
          сразу, второй сериал по Семенову. Не такой большой, шестисерийный, но
          я понимал, что это всё-таки другая орбита, и надо действовать
          напрямую: аудитория – миллионы, он пойдет по Первой программе.{" "}
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/knaifel/source">[C—A]</Link>
          </sub>
        </>
        <Spacer half size={4} />
        <Carousel
          autoHeight
          slides={[
            { url: `${PUBLIC_URL}/assets/images/knaifel/cinema/07/9.jpg` },
            { url: `${PUBLIC_URL}/assets/images/knaifel/cinema/07/10.jpg` },
            { url: `${PUBLIC_URL}/assets/images/knaifel/cinema/07/11.jpg` },
          ]}
        />
      </BlockCinema>
      <Spacer half size={4} />
      <BlockCinema black>
        <Freedom />
        <Spacer half size={8} />
        <SubTitle inverted>гераклит</SubTitle>
        <Text>александр кнайфель:</Text>
        <>
          А я в этот момент как раз заканчивал свою работу над Гераклитом. Это
          совершенно невероятная вещь, погружение, почти два года интенсивной
          работы. Я чувствовал, что у меня возник новый опыт, в каком-то смысле
          я родился уже другим человеком и к моменту «Противостояния» был готов
          чисто личностно совсем на другом уровне.{" "}
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link style={{ color: "#fff" }} to="/knaifel/source">
              [C—A]
            </Link>
          </sub>
        </>

        <Spacer half size={4} />
        <>георгий ковалевский:</>
        <>
          В начале 80-х годов Кнайфеля очень увлекает идея космогонии, творения
          мира и Вселенной, вещи, связанные с пространством, в том числе и с
          космосом. И он обращается к Античности, к текстам Гераклита, для себя
          решив, что он эти тексты будет озвучивать.{" "}
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link style={{ color: "#fff" }} to="/knaifel/source">
              [C—C]
            </Link>
          </sub>
        </>

        <Spacer half size={4} />
        <SubTitle inverted>«ника»</SubTitle>
        <Text>александр кнайфель:</Text>
        <>
          В 1982 году мне привиделся-прислышался ансамбль контрабасовых
          «сфинксов». И тут совпало – судьба свела меня с великим ученым
          Александром Иосифовичем Зайцевым, автором книг «Культурный переворот в
          Древней Греции VIII–V вв. до н.э.». Своей рукой Зайцев сделал мне
          переводы Гераклита заново.
        </>
        <>
          Каждая эпоха ведь искала ответы на вечные вопросы именно у Гераклита.
          И вот, на основе семидесяти (из ста сорока) уцелевших фрагментов «О
          природе» я стал выстраивать композицию – от большого взрыва до
          формирования мироздания, потом Земля, человек, все человеческие и
          нравственные проблемы.
        </>
        <>
          Возникло нечто циклопическое, заканчивающееся последними тринадцатью
          строками дантевского «Рая».
        </>
        <>
          Я взял строчку из стихотворения феноменально одарённой пятилетней
          девочки Ники Турбиной: «Не я пишу свои стихи». И, чтобы свести
          громадину возникшего к лёгкости частного прикосновения, так и назвал
          её –<NBSP />
          <a
            href="https://youtu.be/6OQAI7Qjzeg"
            style={{
              borderBottom: "1px solid #ccc",
              color: "#fff",
            }}
          >
            «Ника»
          </a>
          .{" "}
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link style={{ color: "#fff" }} to="/knaifel/source">
              [C—A]
            </Link>
          </sub>
        </>

        <Spacer half size={4} />
        <>георгий ковалевский:</>
        <>
          Соединились Гераклит, Античность, Данте, как финальная космогоническая
          картина и Ника, которая каким-то особенным образом улавливала тексты.
        </>

        <Spacer half size={4} />
        <SubTitle inverted>невозможность существования вне слова</SubTitle>
        <>
          В «Нике» Кнайфель впервые подписывает текст под нотными строчками
          инструменталистов, в том числе и для тех, кто не имеет возможности его
          произносить.{" "}
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link style={{ color: "#fff" }} to="/knaifel/source">
              [C—C]
            </Link>
          </sub>
        </>

        <Spacer half size={4} />
        <Text>александр кнайфель:</Text>
        <>
          С середины 1980-х практически все сочинения так написаны. Если слово
          попадает на возможность его пропеть, оно пропевается, если не попадает
          – не слышно, но всё равно оно живёт. Являет материю. И так же, как в
          «Жанне» открылась сияющая форма существования в числе, в последующих
          сочинениях обнаружилась невозможность существования вне слова.{" "}
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link style={{ color: "#fff" }} to="/knaifel/source">
              [C—A]
            </Link>
          </sub>
        </>
      </BlockCinema>

      <Spacer half size={8} />

      <BlockCinema>
        <SubTitle>противостояние со злом как симфоническое обобщение</SubTitle>
        <Text>александр кнайфель:</Text>
        <>
          В «Противостоянии» мне вдруг явился образ – противостояние
          неустранимости и неизбывности зла, с которым приходится все время
          сражаться миру со дня основания. Меняются времена, но противостояние
          со злом никуда не девается. И оно на уровне симфонического обобщения.
          Поэтому мне захотелось выйти за пределы кинематографических
          представлений, уйти в жанр, совершенно не свойственный кино.
        </>

        <Spacer half size={4} />
        <SubTitle>симфония в три минуты</SubTitle>
        <>
          Симфония – в житейском смысле это же максимальное созвучие
          всевозможных понятий. Людям, никаким образом с музыкой не связанным,
          пойти в филармонию и послушать целое отделение невмоготу, по разным
          причинам. А<NBSP />
          <a
            href="https://music.yandex.ru/album/35413752/track/136149402"
            style={{
              borderBottom: "1px solid #ccc",
            }}
          >
            симфонию, которая длится три минуты
          </a>
          , – это совсем другое, они уже будут иметь представление, что музыка
          может поднять на иную высоту. У меня был невероятный драйв, парадокс –
          симфония, которую нужно уложить в три минуты!
        </>
        <Spacer half size={4} />
        <Carousel
          autoHeight
          slides={[
            { url: `${PUBLIC_URL}/assets/images/knaifel/cinema/07/2.jpg` },
            { url: `${PUBLIC_URL}/assets/images/knaifel/cinema/07/3.jpg` },
            { url: `${PUBLIC_URL}/assets/images/knaifel/cinema/07/4.jpg` },
          ]}
        />
        <Spacer half size={4} />
        <SubTitle>музыка – вестник грядущего</SubTitle>
        <>
          Само название – «Противостояние» – во многом ключ к музыкальному
          решению. Люди теряют ориентиры, они как слепые котята, а музыка эти
          ориентиры создает. Музыка – это вестник грядущего. Это единственное,
          что она может, но это и немало.{" "}
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/knaifel/source">[C—A]</Link>
          </sub>
        </>
        <Spacer half size={4} />
        <Carousel
          autoHeight
          slides={[
            { url: `${PUBLIC_URL}/assets/images/knaifel/cinema/07/5.jpg` },
            { url: `${PUBLIC_URL}/assets/images/knaifel/cinema/07/6.jpg` },
          ]}
        />
        <Spacer half size={4} />
        <SourceText>
          Правда самой музыки прошибает все.
          <br />
          (дневник)
          <br />
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            [E—I]
          </sub>
        </SourceText>
        <Spacer half size={4} />
        <>
          И она потрясает: вы чувствуете, что с одной стороны вы один, но с
          другой – совсем не один. Все становятся в этот момент родными, и
          переживают вместе – это уже совсем другая ситуация.
        </>
        <Spacer half size={4} />
        <SubTitle>к трону на поклон</SubTitle>
        <>
          После премьеры фильма было собрание, тогда я еще имел причастность и
          входил в Союз кинокомпозиторов. Особняк Монферрана, маленькая
          лестница, я стою и с кем-то разговариваю. И вдруг весь Союз
          выстраивается в очередь и, знаете, как на поклон к трону идут с
          приношениями. Вкусы разные, стили разные, но сквозь все это возникла
          повязанность – это самое главное.
        </>

        <Spacer half size={4} />
        <SubTitle>финальные титры</SubTitle>
        <>
          «Противостояние» – огромная картина, ее нужно было чем-то насыщать, и
          тут поступило предложение из «Госкино» переделать картину определенным
          образом. Аранович продолжает монтировать, ему явно не хватает
          музыкального материала, чтобы ткань все время жила. И вдруг он
          случайно напал на конец этой фонограммы, где идет невероятно
          изматывающий ритм: три-два-два-три, три-два-два-три и так далее. Идет
          большой хвост с этим ритмом, уходит, уходит, уходит – так было
          задумано. «Я напал на золотую жилу!» И стал копировать это в
          чудовищном количестве: если этот хвост шел не больше минуты, то он
          его, наверное, раз сто повторил. Монтажеры говорили: «Мы уже просто
          устали копировать». Килограммами, тоннами. И я чувствовал, что и ему
          стало жить нормально, и музыка теперь зажила в кадре.{" "}
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/knaifel/source">[C—A]</Link>
          </sub>
        </>
        <Spacer half size={4} />
        <QuoteCinema>
          <QuoteCinemaText>аркадий штейнлухт:</QuoteCinemaText>
          <>
            Это, конечно, фантастическая фонограмма, необычный оркестровый
            состав: как правило используют три тромбона, тубу и две трубы, а тут
            – шесть тромбонов, две тубы и четыре трубы! Здесь все дело в
            мощности звучания. Скрипачи потом отдельно накладывались, потому что
            у них ритм был поперек, а ударные и медные – все вживую. Потом ее
            пытались исполнять в концерте, но это очень трудно, она
            специфическая, рассчитана на сочетания инструментов в ансамбле
            именно для звукозаписи.{" "}
            <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
              <Link to="/knaifel/source">[C—D]</Link>
            </sub>
          </>
        </QuoteCinema>
        <Spacer half size={4} />
        <SubTitle>такой состав не собрать</SubTitle>
        <Text>александр кнайфель:</Text>
        <>
          Есть у меня ряд кинематографических фонограмм, которые были написаны
          именно в расчете на звукозапись, то есть не на классический состав.
          Например, в «Противостоянии» был использован 24-канальный Ampex,
          который только-только поставили на студии. И все каналы были заполнены
          разными составами исполнителей.
        </>
        <>
          Если подобные фонограммы исполнять в концерте, возникают проблемы –
          такой состав просто не собрать.{" "}
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/knaifel/source">[C—A]</Link>
          </sub>
        </>
        <Spacer half size={4} />
        <Image
          alt="Александр Кнайфель"
          src={`${PUBLIC_URL}/assets/images/knaifel/cinema/07/7.jpg`}
        />
        <Spacer half size={4} />
        <SubTitle>вальс</SubTitle>
        <>
          Была интересная история с вальсом. Уже предстояла запись, составлена
          смета... Накануне записи, часов в девять вечера, позвонил Арановичу.
          Он: «Да, вот бы хорошо начать так: мирный вечер, звучит вальс, и
          пошел-пошел!» Я тихо торопею, а он очень красиво умеет все это
          развивать, у него все быстро рождается и он это видит как кино. «А
          запись-то вообще завтра!» – но он как-то промолчал. Я судорожно
          схватился за работу, позвонил музыкальному редактору, попросил нотных
          переписчиков на завтра. И сел. От духового вальса, через расстроенный
          рояль, через колокола, через балалайки, через голоса. А мелодия – как
          будто не я ее сочинил. Она напоминает миллион других всяких вальсов,
          не буквально, но ассоциативным полем.{" "}
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/knaifel/source">[B—C]</Link>
          </sub>
        </>

        <>
          Приходит момент, и я говорю: «Семен, сделал я тебе вальс». – «Какой
          вальс? Мне никакой вальс не нужен». А я вложился в него, не просто
          так. А у нас несколько дней подряд записи идут, но на третий день у
          него какие-то дела, и он утром не придет. Я говорю: «Давайте писать
          вальс!» Музыканты как нюхом чувствуют, что надо это сделать. И
          действительно – взяли и записали. Все лежат, счастливы: «Мы тут такой
          вальс записали». Но Аранович очень чуткий, он видел, что происходит.{" "}
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/knaifel/source">[C—A]</Link>
          </sub>
        </>

        <Spacer half size={4} />
        <i>
          Когда возникает музыка – сценарий вырастает своей первой буквой.{" "}
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/knaifel/source">[E—I]</Link>
          </sub>
        </i>

        <Spacer half size={4} />
        <>
          Дальше ситуация такая: были съемки в ГДР, в Трептов парке, там большой
          мемориал. И они сняли таблички с именами-фамилиями, которым конца и
          края нет. И на всякий случай этот материал у них в загашнике лежит.
          Лежит и лежит, идет монтаж. И опять такая же ситуация, как с
          «Торпедоносцами»: неизвестно, как заканчивать. Изначально ему было
          важно показать природу человеческой измены, и он напал на жуткие
          кадры, когда изменники едят. А потом специально доснял, как развозят
          на тележках пищу, как кормят. У него было много вариантов.
        </>
        <>
          И вдруг я вспоминаю Трептов парк, вечный огонь, и начинается
          <NBSP />
          <a
            href="https://music.yandex.ru/album/35413752/track/136149401"
            style={{
              borderBottom: "1px solid #ccc",
            }}
          >
            вальс
          </a>
          . Все четыре минуты идут эти кадры, ничего кроме них. Они идут и идут.
        </>

        <Spacer half size={4} />
        <SubTitle>узнают как свою</SubTitle>
        <>
          В вальсе тема, словно у нее нет автора. Ну вот нет автора! Никто ее не
          сочинил, это такая субстанция, которая таинственным образом объединяет
          всех, кто воюет. Там сплав ностальгии по времени, по семьям, по
          воспетому. Такая согретость.
        </>

        <Spacer half size={4} />
        <SubTitle>как символ необходимости сражения</SubTitle>
        <>
          Этот вальс не сочинённый, он как будто бы существует от века. Причём
          не как венский вальс, не как торжество какого-то полета, красоты,
          принятия мира, а именно как символ необходимости сражения.
        </>
        <Spacer half size={4} />
        <Image
          alt="Александр Кнайфель"
          src={`${PUBLIC_URL}/assets/images/knaifel/cinema/07/8.jpg`}
        />
        <Spacer half size={4} />
        <SubTitle>дитя войны</SubTitle>
        <>
          Я же дитя войны. Я родился в самом узловом моменте, когда судьба
          цивилизации… поймите, март 1943-го года – не известно вообще, что
          могло быть.{" "}
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/knaifel/source">[C—A]</Link>
          </sub>
        </>
      </BlockCinema>

      <Spacer half size={8} />

      <BlockCinema black>
        <Freedom />
        <Spacer half size={8} />
        <SubTitle inverted>agnus dei</SubTitle>
        <>
          Через год, в 1985-м, возник мой
          <NBSP />
          <a
            href="https://youtu.be/_NqERSciTP4 "
            style={{
              borderBottom: "1px solid #ccc",
              color: "#fff",
            }}
          >
            «Agnus Dei»
          </a>
          <NBSP />– это особое сочинение. Заказали его в Германии, но у них своё
          представление о войне. Я говорю: «Знаете что? Пусть знают, что значит
          заказывать про войну питерскому еврею!» И я наотмашь, взял и сделал.
          Её исполнять дважды вообще невозможно, это как приглашение на казнь.
          Надо было вжиться в эту невозможную ситуацию.{" "}
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link style={{ color: "#fff" }} to="/knaifel/source">
              [C—A]
            </Link>
          </sub>
        </>

        <Spacer half size={4} />
        <>георгий ковалевский:</>
        <>
          «Agnus Dei» («Агнец Божий») – камерное произведение Александра
          Кнайфеля, посвящённое жертвам ленинградской блокады. В исполнении
          участвуют 4 музыканта, играющие на ударных, духовых и электронных
          инструментах. Литературной основой сочинения стал дневник
          ленинградской школьницы Тани Савичевой, потерявшей в годы блокады всех
          своих родственников. Текст в этой музыке существует внутри партий
          инструменталистов, он не произносится вслух, но существует как
          интонационная и ритмическая основа.{" "}
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link style={{ color: "#fff" }} to="/knaifel/source">
              [C—C]
            </Link>
          </sub>
        </>

        <Spacer half size={4} />
        <>
          Как я написал в «Agnus Dei»: «Это моё вечное поклонение за мою вечную
          вину рождения не в Петербурге!»{" "}
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link style={{ color: "#fff" }} to="/knaifel/source">
              [B—C]
            </Link>
          </sub>
        </>
      </BlockCinema>

      {/* ---------------------------------------------------------- */}
      <Spacer size={15} />
      <FilmCover
        director="реж. семен аранович"
        name={["«большая игра»", "«личное дело анны ахматовой»"]}
        url={`${PUBLIC_URL}/assets/images/knaifel/cinema/08/1.jpg`}
        year={["1988", "1989"]}
      />
      <Spacer half size={8} />
      <BlockCinema>
        <SubTitle>почему?</SubTitle>
        <Text>александр кнайфель:</Text>
        <>
          Тут, к сожалению, у Семена [Арановича] произошёл какой-то сдвиг и
          прокол, и он это прекрасно понимал. Детская история про переворот в
          какой-то южной стране. Как он в это втюхался…? Это было совместное
          производство с Болгарией. Он и хороших актёров взял, но уже изначально
          было непонятно – почему?
        </>

        <Spacer half size={4} />
        <SubTitle>католическая молитва</SubTitle>
        <>
          В моей судьбе это совпало с трагической страницей: в этот момент
          уходил из жизни мой отец. А в основе фильма было совершенно гениальное
          стихотворение Заболоцкого «Начало зимы»: «Я наблюдал, как речка
          умирала…»
        </>
        <Spacer half size={4} />
        <Carousel
          autoHeight
          slides={[
            { url: `${PUBLIC_URL}/assets/images/knaifel/cinema/08/2.jpg` },
            { url: `${PUBLIC_URL}/assets/images/knaifel/cinema/08/3.jpg` },
          ]}
        />
        <Spacer half size={4} />
        <>
          И я впервые сделал католическую молитву – Litania. Ее первая часть,
          <NBSP />
          <a
            href="https://music.yandex.ru/album/35413752/track/136149410 "
            style={{
              borderBottom: "1px solid #ccc",
            }}
          >
            Miserere
          </a>
          , была использована в «Большой игре». Семен понимал, в каком я
          нахожусь состоянии, он вообще всё принимал, что я делаю. Слушал.{" "}
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/knaifel/source">[C—A]</Link>
          </sub>
        </>
        <Spacer half size={4} />
        <Image
          alt="Александр Кнайфель"
          src={`${PUBLIC_URL}/assets/images/knaifel/cinema/08/4.jpg`}
        />
        <Spacer half size={4} />
        <QuoteCinema>
          <SubTitle>пропевать внутри</SubTitle>
          <QuoteCinemaText>аркадий штейнлухт:</QuoteCinemaText>
          <>
            …музыканты получили ноты со словами, которые они не должны были
            произносить вслух. Для меня это была первая партитура, когда слова
            подписывались под инструменты («Ника», написанная в 1984 году, где
            впервые использовалось слово, как незвучащая субстанция, была
            исполнена только в 1992-м на фестивале во Франкфурте. – Примеч.
            авт.). Струнные еще, допустим, могли бы их произносить, хотя этого и
            не нужно было, но духовым это уж никак бы не удалось, они должны
            были только в голове их читать. Не играть ноты, а пропевать их. И я
            тоже, разумеется.{" "}
            <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
              <Link to="/knaifel/source">[C—D]</Link>
            </sub>
          </>
        </QuoteCinema>
        <Spacer half size={4} />
        <Image
          alt="Александр Кнайфель"
          src={`${PUBLIC_URL}/assets/images/knaifel/cinema/08/5.jpg`}
        />
        <Spacer half size={4} />
        <QuoteCinema>
          <SubTitle>разбитая посуда и пулемет</SubTitle>
          <QuoteCinemaText>аркадий штейнлухт:</QuoteCinemaText>
          <>
            На запись принесли сэмплер, там были не только музыкальные тембры,
            но еще и самые разные звуки: разбитая посуда, пулемет, что-то еще. И
            Аранович так вдохновился этим, что сам стал на нем играть и
            записывать. Обычно он был суровый, насупленный, а тут веселился как
            ребенок. Первый раз его таким видел.{" "}
            <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
              <Link to="/knaifel/source">[C—D]</Link>
            </sub>
          </>
        </QuoteCinema>
        <Spacer half size={4} />
        <SubTitle>очевидный провал</SubTitle>
        <Text>александр кнайфель:</Text>
        <>
          В этом сценарии что-то было настолько непохожее на то, что делал
          всегда Аранович. Я не могу понять, что его подвигло… Это была повесть
          того же Семенова, называлась «Пресс-центр». Вообще, в содружестве с
          Юлианом что-то ему нравилось. И, надо сказать, что «Противостояние»
          ему удалось сделать моментами очень сильным, хоть и не до конца, как
          он хотел. А тут он хотел продолжить, но это был очевидный провал.
          Просто провал. Но дальше… он начал делать потрясающие документальные
          фильмы!{" "}
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/knaifel/source">[C—A]</Link>
          </sub>
        </>
        <Spacer half size={4} />
        <QuoteCinema>
          <SubTitle>время не для большого кино</SubTitle>
          <QuoteCinemaText>любовь аркус:</QuoteCinemaText>
          <>
            «Большая игра» – для Арановича просто заработок. Но и в этой картине
            Аранович – огромный мастер. В том, что он перестал снимать игровое
            кино, не нужно искать никакого кризиса. Арановичу показалось, что
            это выгоднее, ему дали большие деньги – он открыл свою студию
            «Кинодокумент», делал копродукцию с иностранцами. В отличии от
            многих, хорошо понимал, что наступающее время уже не для большого
            кино. А это ему было делать интересно. Это очень хорошие
            документальные фильмы своего времени. Надо еще понимать, что он снял
            похороны Ахматовой сам, своей камерой.{" "}
            <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
              <Link to="/knaifel/source">[C—E]</Link>
            </sub>
          </>
        </QuoteCinema>
        <Spacer half size={4} />
        <SubTitle>изгибы сюжета</SubTitle>
        <Text>александр кнайфель:</Text>
        <>
          Это знаменитая съёмка Арановича, 1966 год, история известна. Когда это
          случилось, Анну Андреевну привезли из Москвы, с тем, чтобы похоронить
          на Комаровском кладбище. Аранович работал на Ленинградской студии
          документальных фильмов, он рванул туда со своими операторами и ему
          удалось всё заснять. Они [КГБ] как-то всё пронюхали, и часть этих
          съёмок пропала. Но чудом удалось сохранить изгибы сюжета. Я не знаю,
          выгнали его со студии или нет, но отстранили, был скандал. Эта плёнка,
          всё что осталось – его личная заслуга. И это только часть фильма.
          Остальное связано с тем, что он стал, как всегда, раскапывать архивные
          материалы. Он очень много работал с фотографиями, с их монтажом,
          вглядыванием, поэтому фильм получился довольно ёмкий.{" "}
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/knaifel/source">[C—A]</Link>
          </sub>
        </>
        <Spacer half size={4} />
        <Image
          alt="Александр Кнайфель"
          src={`${PUBLIC_URL}/assets/images/knaifel/cinema/08/6.jpg`}
        />
        <Spacer half size={4} />
        <QuoteCinema>
          <SubTitle>язык ассоциаций, метафор, образов</SubTitle>
          <QuoteCinemaText>семен аранович:</QuoteCinemaText>
          <>
            Я, честно говоря, даже несколько растерялся перед возможностью
            сказать правду о судьбе Ахматовой. Эта возможность пугала
            публицистичностью. Ахматова – не для публицистики. Повторяю,
            возможность сказать всю правду честно, откровенно пугала меня
            прямолинейностью. Мне в этой ситуации ближе был язык ассоциаций,
            метафор, образов. В общем, насколько это в моих силах – язык
            поэтический. [...] Этот фильм должен был нести прежде всего
            эмоциональный, а не информационный заряд. Фильм – не газета.
            Используя факты и документы, мы обязаны вызывать у зрителя
            сопереживание и сочувствие. Мне важен принцип и способ организации
            материала. Здесь необычайно важна личная позиция автора. Я
            категорически не принимаю спекулятивности и проявления личных
            амбиций режиссера в документальном кино за счет своих персонажей!
            Нельзя переходить грань. Эстетические принципы настолько тонки, что,
            переступив их, можно получить эффект, прямо противоположный
            задуманному. Документальный фильм вторгается в саму ткань жизни, а
            поэтому требует особого чувства ответственности…{" "}
            <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
              <Link to="/knaifel/source">[E—A]</Link>
            </sub>
          </>
        </QuoteCinema>
        <Spacer half size={4} />
        <SubTitle>неприцельное. фонограммы из архива</SubTitle>
        <Text>александр кнайфель:</Text>
        <>
          У Арановича в архиве хранились все наши фонограммы, сделанные для
          фильмов, и даже то, что не входило, дубли случайные – все материалы он
          просил сохранять. У меня было целое отделение с коробками. Он любил
          неприцельное, любил иметь сам возможность выбора, перебирал, правил,
          примеривался. Поэтому в случае с «Личным делом…» он использовал мои
          старые фонограммы, там была только одна из новых. Он сам их подбирал,
          больше того, он использовал ещё фрагменты из сочинения Софии
          Губайдулиной «Семь последних слов Христа». Ему было нужно несколько
          звуковых ручек [на пульте перезаписи], которые он, как кулинар,
          соединял в только ему известном сочетании.{" "}
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/knaifel/source">[C—A]</Link>
          </sub>
        </>
      </BlockCinema>

      {/* ---------------------------------------------------------- */}
      <Spacer size={15} />
      <FilmCover
        director="сергей ашкенази"
        name="«криминальный талант»"
        url={`${PUBLIC_URL}/assets/images/knaifel/cinema/09/1.jpg`}
        year="1988"
      />
      <Spacer half size={8} />
      <BlockCinema>
        <SubTitle>ашкенази</SubTitle>
        <Text>александр кнайфель:</Text>
        <>
          Вначале Серёжа написал мне большое письмо, тогда я был популярен –
          «Противостояние», но это было не стихийное обращение на волне, я
          увидел, что он действительно приобщён к музыке и был бы счастлив
          поработать вместе.
        </>
        <Spacer half size={4} />
        <Image
          alt="Александр Кнайфель"
          src={`${PUBLIC_URL}/assets/images/knaifel/cinema/09/2.jpg`}
        />
        <Spacer half size={4} />
        <SubTitle>порождение одесского флера</SubTitle>
        <>
          Этот фильм – очень органичное порождение одесского флера. Тут и
          детектив, и атмосфера, и задача – чтобы было очень съедобно, сочно,
          вкусно. А поскольку моя мама родилась в Одессе, я устремился туда,
          взяв с собой мамочку.
        </>
        <>
          Сам я в Одессе никогда не был, мы с ней бродили по городу: она
          рассказывала, показывала, потому что они там жили в 20-х годах до
          переезда в Ленинград. Водила по дворам, в одном из них нам даже
          удалось найти её соседей, которые многое помнили. Так что это было
          очень волнительно и притом похоже на петербургскую атмосферу.
        </>

        <Spacer half size={4} />
        <SubTitle>дитя в объятиях ночного петербурга</SubTitle>
        <>
          Много снимали и в Петербурге, особенно в белые ночи, как будто бы вся
          история развивалась именно там. Это дало мне ключ – «дитя в объятиях
          ночного Петербурга».
        </>
        <>
          <a
            href="https://music.yandex.ru/album/35413752/track/136149412 "
            style={{
              borderBottom: "1px solid #ccc",
            }}
          >
            «Ноктюрн»
          </a>
          , я так и обозначил. Именно ночной, неизбывно таинственный город, в
          котором и чудеса, и приключения, может быть, не всегда светлые, иногда
          зловещие предчувствия. А среди этого растворён облик юного создания,
          который, как незамысловатый напев, односложный, всё время существует в
          чуть надтреснутом звучании города.
        </>

        <Spacer half size={4} />
        <SubTitle>атмосфера</SubTitle>
        <>
          Фильм держится на крупных планах, диалогах, на очень тонкой
          психологической динамике. Это целая жизнь, которую проживают героиня и
          следователь.
        </>
        <>
          Вроде бы для музыки тут особо и места-то нет, но я понял, что главной
          должна быть атмосфера, то, что за всем этим стоит. Вот они – два
          человека, затерянные в гигантском таинственном пространстве, оно и
          определяет то, что с ними случается.
        </>
        <Spacer half size={4} />
        <Carousel
          autoHeight
          slides={[
            { url: `${PUBLIC_URL}/assets/images/knaifel/cinema/09/3.jpg` },
            { url: `${PUBLIC_URL}/assets/images/knaifel/cinema/09/4.jpg` },
          ]}
        />
        <Spacer half size={4} />
        <SubTitle>метод</SubTitle>
        <>
          Понимая, как работает музыка в кино, я давно освоил такой метод:
          записывал десятиминутную фонограмму на всю часть, которая всегда бы
          существовала под рукой у режиссера на перезаписи. Конечно, меня больше
          всего вдохновлял на это Аранович, реагирующий на музыку очень
          трепетно, глубоко и индивидуально, в том числе и на всякие шумы. Он
          всегда сидел на ручке, пытаясь что-то дополнительно создать в звуковой
          атмосфере. Когда существует этот десятиминутный ролик с музыкой, он
          работает самым неожиданным образом.
        </>
        <Spacer half size={4} />
        <Image
          alt="Александр Кнайфель"
          src={`${PUBLIC_URL}/assets/images/knaifel/cinema/09/5.jpg`}
        />
        <Spacer half size={4} />
        <SubTitle>живительная случайность</SubTitle>
        <>
          Вроде бы случайность, но случайность живительная, которая составляет
          саму суть и жизнь кинематографа. В фильме заведомо существовал более
          глубокий и общий ряд решения звучания картины. Не музыка эпизода, а
          то, что просчитать невозможно. Именно поэтому оно и работает. Но тут
          надо догадаться, какое должно быть звучание.
        </>

        <Spacer half size={4} />
        <SubTitle>заловить</SubTitle>
        <>
          Это вообще мой самый главный принцип. Потому что в искусстве, мне
          кажется, самая главная проблема – догадаться. Суметь заловить как
          антенной то, что совершенно неуловимо, но единственно.
        </>

        <Spacer half size={4} />
        <SubTitle>торжество догадки</SubTitle>
        <>
          Это я говорю к вопросу: а вообще почему у меня роман с кино случился.
          Потому что это чистое свидетельство торжества догадки. Понимаете? Вот
          чувствуешь – объяснить невозможно – опираться на что-то уже
          существующее бессмысленно и бесполезно. Оно, может, и существует, но
          это какая-то другая традиция. В кино надо с чистого листа. На этом
          вообще строится кино, оно для этого. Оно вроде бы сиюминутное, но оно
          фиксирует.{" "}
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/knaifel/source">[C—A]</Link>
          </sub>
        </>
      </BlockCinema>

      {/* ---------------------------------------------------------- */}
      <Spacer size={15} />
      <FilmCover
        director="сергей снежкин"
        name="«невозвращенец»"
        url={`${PUBLIC_URL}/assets/images/knaifel/cinema/10/1.jpg`}
        year="1991"
      />
      <Spacer half size={8} />
      <BlockCinema>
        <SubTitle>гостевой синдром</SubTitle>
        <Text>александр кнайфель:</Text>
        <>
          … у меня гостевой синдром – и в этом мире, и в этой цивилизации. По
          родовому признаку, по начальному ощущению вхождения в мир –
          невероятная... не то что сиротливость, а чувство, что ты – чужак и
          постоянно, жадно ищешь себе подобного… Но есть разные формы
          творческого существования. Естественно, я вживался в те эпохи, через
          которые пролегал мой опыт. Древнегреческая цивилизация, Возрождение,
          эпоха Второй мировой войны… Я жил этим. Я даже принимал
          непосредственное участие в событиях 1991 года.
        </>
        <>
          Путч был 19 августа, а 20-го по Пятому каналу Собчак разрешил премьеру
          фильма Снежкина «Невозвращенец»: на экране по Москве шли
          гипотетические танки, снятые за год до этого. И звучала моя
          <NBSP />
          <a
            href="https://youtu.be/_4gJUfo_QKg"
            style={{
              borderBottom: "1px solid #ccc",
            }}
          >
            «Молитва святого Ефрема Сирина»
          </a>
          . А рядом шли танки документальные.{" "}
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/knaifel/source">[B—F]</Link>
          </sub>
        </>

        <Spacer half size={4} />
        <SubTitle>перестройка</SubTitle>
        <>
          Меня Господь как-то так обустроил, что я был вне всего этого. Я,
          конечно, чисто информационно какие-то вещи понимал и знал, но
          внутренне меня это совершенно никаким образом не задевало. У меня не
          было такой ситуации, что я не мог работать физически. Если не было
          каких-то исполнений, я даже не отдавал себе в этом отчёт. Знал, что у
          меня возникают все новые и новые диалоги с разными эпохами. Возникали
          фильмы – я был только благодарен за это. В какое время они возникали,
          для меня совершенно не играло роли. За исключением
          <NBSP />
          <a
            href="https://music.yandex.ru/album/35413752/track/136149411 "
            style={{
              borderBottom: "1px solid #ccc",
            }}
          >
            фильмов Снежкина
          </a>
          .
        </>

        <Spacer half size={4} />
        <SubTitle>снежкин</SubTitle>
        <>
          Он всегда был невероятно социально заряжен, мне кажется, как только он
          родился, то уже бунтовал – весь как оголённый нерв на текущую
          ситуацию. Я видел, что человек занимает совершенно определённую
          позицию, и мне через него было очень важно приобщиться.
        </>
        <Spacer half size={4} />
        <Image
          alt="Александр Кнайфель"
          src={`${PUBLIC_URL}/assets/images/knaifel/cinema/10/2.jpg`}
        />
        <Spacer half size={4} />
        <SubTitle>первый шаг на пути к крещению</SubTitle>
        <>
          Там всё совпало… Я просто уже понял, что нужно сделать откровенную
          вещь, покаянную молитву, но я также чувствовал, что к ней надо прийти,
          что так просто, без опыта, и не оплатив чем-то – это невозможно. А для
          меня этот этап очень внутренний, потому что это был первый мой шаг на
          пути к Крещению.
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/knaifel/source">[C—A]</Link>
          </sub>
        </>
        <Spacer half size={8} />
        <QuoteCinema>
          <SubTitle>скелеты, обтянутые кожей</SubTitle>
          <QuoteCinemaText>аркадий штейнлухт:</QuoteCinemaText>
          <>
            Тут какая-то вообще мистика. Это июнь 1991 года. У меня уже есть
            свой оркестр, к этому моменту мы сыграли несколько концертов в
            филармонии. Я получаю ноты и ничего не понимаю, потому что вначале
            написаны три солирующих инструмента, у которых струны полностью
            расстроены. Вы себе представляете натяжение басовой струны у скрипки
            – ноту соль? Струна превращается просто в веревку. Зачем? Ему
            необходим был абсолютно немощный, нереальный звук. Представьте себе,
            как люди из лагерей смерти возвращались – скелеты, обтянутые кожей.
            Вот такой звук. Потом эти инструменты через какое-то время
            переставали звучать, но это давало звуковой камертон для всей первой
            части. Следующие тихие звуки были уже не просто тихими, а оттуда
            вырастали. Вся первая часть очень медленная, очень тихая.
          </>
          <Spacer half size={8} />
          <SubTitle>хор деревенской церкви</SubTitle>
          <>
            Конечно, музыканты партитуру восприняли в штыки – мягко сказано. Но
            это было только начало. Когда дошло до второй части, то все должны
            были взять инструмент и смычок в другую руку. Тут начались всякие
            предложения: «Давайте мы вам и так фальшиво сыграем! Зачем вам это
            нужно?» Шурик говорит: «Вы фальшиво-то сыграете, но вы никуда
            мастерство свое не денете, вы играете на инструмент двадцать лет,
            кто-то и дольше. А мне нужно, чтобы было неумело, как человек,
            который взял в руки инструмент первый раз в жизни и при этом
            старается играть чисто. У вас не будет получаться играть чисто, но
            вы будете стараться». Я с ним спорил, ребята с ним спорили, но он
            стоял упорно на своем. Только так и не иначе. Так и играли. Это
            напоминает в какой-то степени хор деревенской церкви, бабок с
            дребезжащими голосами, которые уже не могут петь, но очень
            стараются. Эффект был достигнут. Страшное старание в преодолении
            неумения. Потом и это перестает звучать, и оркестр начинает петь,
            что тоже вызвало вначале неприятие, конечно. Далее все замолкают, и
            только дирижер дирижирует. Но это уже в концерте, на фонограмме,
            естественно, этого нет.
          </>
          <Spacer half size={8} />
          <SubTitle>как гром с неба</SubTitle>
          <>
            И потом, когда начинается третья часть, после длинной-длинной
            тишины, длинного-длинного скрежещущего фальшивого звука, после
            неумелого пения – звучит тихий первый аккорд молитвы, он как гром с
            неба обрушивается.{" "}
            <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
              <Link to="/knaifel/source">[C—D]</Link>
            </sub>
          </>
        </QuoteCinema>
        <Spacer half size={4} />
        <SubTitle>дополнительная емкость</SubTitle>
        <Text>александр кнайфель:</Text>
        <>
          Когда человек пытается передать то, что не может передать его
          инструмент, возникает дополнительная емкость, которую ничем иным
          создать невозможно. И мне очень важен не результат, а взыскуемость
          результата.
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/knaifel/source">[B—I]</Link>
          </sub>
        </>
      </BlockCinema>

      {/* ---------------------------------------------------------- */}
      <Spacer size={15} />
      <FilmCover
        director="сергей ашкенази"
        name="«любовь. смертельная игра...»"
        url={`${PUBLIC_URL}/assets/images/knaifel/cinema/11/1.jpg`}
        year="1991"
      />
      <Spacer half size={8} />
      <BlockCinema>
        <SubTitle>второй шаг</SubTitle>
        <Text>александр кнайфель:</Text>
        <>
          Второй шаг [на пути к Крещению] был непосредственно в том же году –
          это был
          <NBSP />
          <a
            href="https://youtu.be/ASDAqWyoulw"
            style={{
              borderBottom: "1px solid #ccc",
            }}
          >
            «Свете тихий»
          </a>
          . Мы записали маленькую всенощную с голосом Татьяны Ивановны. Поводом
          тоже был фильм.
        </>
        <>
          Тут произошла такая вещь: лето 1991 года, Танечка была на каких-то
          зарубежных гастролях, а мне в эти белые ночи вдруг явилась невероятная
          идея. Я еще не знал, на каком именно материале, но чувствовал – что-то
          из службы. И потом понял, что это должна быть Пресвятая Богородица.
          Простейшая догадка, но пронзительная. У Татьяны уникальный, признанный
          всеми тембр, а я тогда уже достаточно много работал с Андреем Сигле.
        </>

        <Spacer half size={4} />
        <SubTitle>андрей сигле</SubTitle>
        <>
          Он был прирожденно склонен к кинематографу, по слуху. Работал с
          Сокуровым, с Каравайчуком. Он, конечно, не композитор, но для кино –
          просто идеален. Более того, он был дистрибьютором сэмплерных аппаратов
          AKAI. Каждую новую модель получал на тестирование. Очень трепетно
          относился к звуку.
        </>

        <Spacer half size={4} />
        <SubTitle>часть моего словаря</SubTitle>
        <>
          Я вошел по времени в звукозапись, когда только стали появляться первые
          сэмплеры. А в моих сочинениях сэмплы играют огромную роль.
        </>
        <>
          Я первый освоил многие вещи. Этого опыта у большинства моих коллег
          просто нет. Все, связанное со звукозаписью, с включением магнитофонной
          фонограммы, с обработкой звука – все это для меня органично и в
          концертных вещах. Это часть моего словаря.
        </>

        <Spacer half size={4} />
        <SubTitle>воспитание звукового сознания</SubTitle>
        <>
          И, если бы я не работал в кино, сэмплов, разумеется, не было бы. А так
          на этом воспиталось мое звуковое сознание.
        </>

        <Spacer half size={4} />
        <SubTitle>«свете тихий»</SubTitle>
        <>
          Самый яркий пример – это «Свете тихий». Там все партии записаны
          голосом Татьяны Ивановны, это такая маленькая всенощная. Первая часть
          – Благовест, потом сама Песнь Богородицы, и завершающая – Свете тихий.
        </>
        <Spacer half size={4} />
        <Image
          alt="Александр Кнайфель"
          src={`${PUBLIC_URL}/assets/images/knaifel/cinema/11/2.jpg`}
        />
        <Spacer half size={4} />
        <SubTitle>в отечественной музыке</SubTitle>
        <>
          В отечественной музыке, а теперь можно сказать, что и в мировой, это
          был первый опыт, очень яркий. Плоть от плоти порождение моего
          существования в кино.
        </>

        <Spacer half size={4} />
        <SubTitle>с какой стати я?</SubTitle>
        <>
          Для меня это был невероятно жадный интерес. Возникает какой-нибудь
          фильм, например, «Требуются мужчины». Там строят плотину – и это был
          повод для меня, чтобы сделать
          <NBSP />
          <a
            href="https://music.yandex.ru/album/35413752/track/136149399"
            style={{
              borderBottom: "1px solid #ccc",
            }}
          >
            подобие нового рока
          </a>
          . Или дальше было
          <NBSP />
          <a
            href="https://music.yandex.ru/album/35413752/track/136149407"
            style={{
              borderBottom: "1px solid #ccc",
            }}
          >
            диско для «Узбекфильма»
          </a>
          . И так далее. То есть жанры, к которым я никогда бы не подступился. С
          какой стати? Не было повода. А так, наоборот, мне становилось страшно
          интересно: чем более неожиданный ракурс, тем интереснее. Мне надо было
          это вписать в культуру звучащего вокруг мира.
        </>

        <Spacer half size={4} />
        <SubTitle>богородица, фестиваль в цюрихе и просто детектив</SubTitle>
        <>
          И в этот раз я понимал, что мою невероятную идею просто необходимо
          воплотить, но как? Для этого нужны условия. И тут музыка посылает мне
          сигналы подряд в течении полутора суток. Сначала звонят из Цюриха с
          Фестиваля новой музыки: «Мы ждем от вас какое-то новое сочинение».
          Буквально через сутки после этого звонок с Одесской студии по следам
          нашего «Криминального таланта»: «Мы будем снимать новый детектив и
          очень хотели бы, чтобы вы нам помогли». И тут я своим ловким умом – я
          был заряжен, я пламенел – понял, что все сходится. Я согласился и
          сказал, что немедленно еду смотреть материал.
        </>
        <>
          Отправляюсь в Одессу. Фильм про какую-то воровку, называется «Любовь –
          смертельная игра…». Это далеко не «Криминальный талант», просто
          детектив, немножечко перепев. Я чистым незамутненным взглядом
          посмотрел, они ждут, что я скажу. «Вы представляете, до чего я дошел:
          ваша героиня мне невероятным образом напоминает Богородицу». Мне
          показалось, что это может быть ключом.
        </>

        <Spacer half size={4} />
        <SubTitle>сотканное из ручной работы</SubTitle>
        <>
          Возвращаюсь домой, в течение трех дней пишу всю партитуру, как раз к
          исходу третьего дня приезжает Татьяна. Сходу я беру ее в оборот, и два
          дня без перерыва мы с ней пытаемся освоить этот материал. А на третий,
          то есть уже на шестой день работы, заказываем студию на «Ленфильме» с
          Андрюшей Сигле и его AKAI. Приезжает режиссер со своей группой, мы
          начинаем запись.
        </>
        <>
          Дело в том, что там есть невероятно громоздкие и трудовые вещи.
          Например, нужно чтобы в хоре все сэмплы звучали натурально, на каждую
          гласную у них был свой тембр, не только тон, но и тембр. Это
          сумасшествие! Я не знаю, кто кроме Сигле мог бы справиться. Каждое
          слово, ансамбли, хор – близкий и далекий – это масса всего на свете.
        </>
        <>
          Вы представляете себе? Это получилось за шесть суток от момента
          зарождения до реализации – невероятно! Получасовая вещь, вся сотканная
          из ручной работы.
        </>

        <Spacer half size={4} />
        <SubTitle>«pet shop boys»</SubTitle>
        <>
          Когда запись уже была издана на Западе, фрагменты ее вошли в один из
          самых популярных треков «Pet shop boys» (Psychological, 2006 год), а
          потом их использовали всякие крутые ди-джеи. Эта фонограмма всюду была
          на поверхности, да и продолжает быть.
        </>

        <Spacer half size={4} />
        <SubTitle>для девичьего хора</SubTitle>
        <>
          Спустя какое-то время меня очень просили сделать версию для девичьего
          хора, которую можно исполнять вживую.
        </>

        <Spacer half size={4} />
        <SubTitle>версия для храма</SubTitle>
        <>
          А потом для Цюриха я отделил фонограмму, которая идет как бы
          непосредственно от первого голоса Богородицы, ото всего остального:
          вторящих, эха, хоров, корифеев из хора. Мы выделили эту дорожку
          отдельно, и получилось, что дали жизнь такому исполнению, при котором
          мы заселялись в храм, ставили динамики прямо в потолок – в зависимости
          от конструкции храма – и давали фонограмму. А Татьяна Ивановна живьем
          с ней пела. С таким исполнением мы объездили почти всю Европу.
        </>
        <Spacer half size={4} />
        <Image
          alt="Александр Кнайфель"
          src={`${PUBLIC_URL}/assets/images/knaifel/cinema/11/3.jpg`}
        />
        <Spacer half size={4} />
        <SubTitle>часть божьего промысла</SubTitle>
        <>
          Таково происхождение очень многих вещей, которые у меня существуют
          исключительно благодаря творческим импульсам. Были более к ним
          привязанные, а были такие, что вот картина, надо ее сделать, и во
          многих случаях это спасало. Еще были ситуации с фильмами, когда я
          понимал, что просто отказаться – это не в моем характере. Не из-за
          заработка, а потому, что ко мне обращаются. И я всегда это воспринимаю
          как некий знак сверху, как часть Божьего промысла, к которому надо
          отнестись с посильным вниманием.
        </>
        <Spacer half size={4} />
        <Image
          alt="Александр Кнайфель"
          src={`${PUBLIC_URL}/assets/images/knaifel/cinema/11/4.jpg`}
        />
        <Spacer half size={4} />
        <SubTitle>дополнительные легкие</SubTitle>
        <>
          Благодаря возможностям кино, я был предоставлен во всей полноте своей
          свободе, за что всегда чувствовал признательность. И это возвращалось
          бумерангом: возникало то неповторимое, что в рамках академической
          музыки, возможно, даже бы и не состоялось. То есть кинематограф был
          для меня такими дополнительными легкими.
        </>
        <>
          Эти вещи рождены в кино, по звучанию и качеству они выбивались из ряда
          привычных академических работ, несли отпечаток по целому ряду
          составляющих. Тем не менее они становились как будто бы
          академическими: исполнялись, большинство из них и сейчас звучит, и
          никто понятия не имеет, что они написаны для кино. И их большинство.
          <sub style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>
            <Link to="/knaifel/source">[C—A]</Link>
          </sub>
        </>
      </BlockCinema>

      <Spacer half size={30} />

      <Footer />
    </TypographyWrapper>
  );
};

export default Cinema;
